(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function init(bar) {
      if (bar.dataset.tapPauseBound === '1') return;
      bar.dataset.tapPauseBound = '1';

      bar.addEventListener('click', function () {
        bar.classList.toggle('is-paused');
      });
    }

    function bootstrap() {
      var bars = document.querySelectorAll('[data-announcement-bar]');
      bars.forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.bound === 'true') return;
      root.dataset.bound = 'true';

      var section = root.closest('.blog-cards');
      if (!section) return;

      var grid = section.querySelector('.blog-cards__grid');
      var button = root.querySelector('[data-blog-cards-view-more]');
      var statusEl = root.querySelector('[data-blog-cards-status]');
      var progressEl = root.querySelector('[data-blog-cards-progress]');
      var fallback = section.querySelector('.blog-cards__view-more--fallback');
      if (fallback) fallback.style.display = 'none';

      if (!grid || !button) return;

      var visible = parseInt(root.dataset.visible || '0', 10);
      var total = parseInt(root.dataset.total || '0', 10);
      var perPage = parseInt(root.dataset.perPage || '16', 10);
      var currentPage = parseInt(root.dataset.currentPage || '1', 10);
      var totalPages = parseInt(root.dataset.totalPages || '1', 10);
      var basePath = window.location.pathname;

      function updateChrome() {
        if (statusEl) {
          // Concatenate the status text directly. Translators can override
          // by setting the full sentence on a data-attribute and reading
          // it from there if i18n is needed.
          statusEl.textContent = "You've viewed " + visible + ' of ' + total + ' posts';
        }
        if (progressEl) {
          var pct = total > 0 ? (visible / total) * 100 : 0;
          progressEl.style.width = pct + '%';
        }
        if (visible >= total || currentPage >= totalPages) {
          root.setAttribute('hidden', '');
        }
      }

      function appendCards(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('.blog-cards__grid');
        if (!nextGrid) return 0;
        var items = nextGrid.querySelectorAll(':scope > .blog-cards__item');
        for (var i = 0; i < items.length; i++) {
          grid.appendChild(items[i]);
        }
        return items.length;
      }

      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (button.disabled) return;
        button.disabled = true;
        var nextPage = currentPage + 1;
        var sectionId = section.closest('.shopify-section').id.replace('shopify-section-', '');
        // Fetch URL uses section_id so Shopify returns just the section's
        // markup (not the full page); display URL is the clean ?page=N
        // that the user/back-button can navigate to.
        var fetchUrl = basePath + '?page=' + nextPage + '&section_id=' + sectionId;
        var displayUrl = basePath + '?page=' + nextPage;
        fetch(fetchUrl, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var added = appendCards(html);
            currentPage = nextPage;
            visible = Math.min(visible + added, total);
            root.dataset.visible = visible;
            root.dataset.currentPage = currentPage;
            // Update the URL so refresh + bookmarking + the browser back
            // button all land back on the same loaded state. pushState
            // adds a new history entry per click; replaceState would
            // collapse them -- use pushState so back button steps
            // through the load history naturally.
            try {
              window.history.pushState({ blogCardsPage: nextPage }, '', displayUrl);
            } catch (e) { /* private mode or sandboxed iframe; non-fatal */ }
            updateChrome();
            button.disabled = false;
          })
          .catch(function () {
            button.disabled = false;
          });
      });
    }

    document.querySelectorAll('[data-blog-cards-pagination]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-ticker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var initialised = new WeakSet();
    var DEBOUNCE_MS = 150;

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        var ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }

    function updateDuration(root) {
      var track = root.querySelector('[data-brand-ticker-track]');
      if (!track) return;
      var halfWidth = track.scrollWidth / 2;
      if (!halfWidth) return;
      var speed = parseFloat(root.style.getPropertyValue('--brand-ticker-speed')) || 50;
      var seconds = halfWidth / speed;
      root.style.setProperty('--brand-ticker-duration', seconds + 's');
    }

    function init(root) {
      if (initialised.has(root)) return;
      initialised.add(root);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () { updateDuration(root); });
      });

      var debounced = debounce(function () { updateDuration(root); }, DEBOUNCE_MS);
      window.addEventListener('resize', debounced);

      if (typeof ResizeObserver !== 'undefined') {
        var track = root.querySelector('[data-brand-ticker-track]');
        if (track) {
          var ro = new ResizeObserver(debounced);
          ro.observe(track);
        }
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-brand-ticker]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FOCUSABLE_SELECTOR =
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function findRoot() {
      return document.querySelector('[data-cart-drawer]');
    }

    function findBackdrop() {
      return document.querySelector('[data-cart-drawer-backdrop]');
    }

    function CartDrawer(root) {
      this.root = root;
      this.backdrop = findBackdrop();
      // Sibling of the root, not a descendant -- see the comment on the
      // element itself. Cached because nothing ever replaces it.
      this.shippingAnnounce = document.querySelector('[data-shipping-announce]');
      this.isOpen = false;
      this.isUpdating = false;
      this.previousFocus = null;

      // #218: per-row optimistic-update state, keyed by the STABLE
      // data-line-key (never the re-indexed data-line). `_lineDebounce`
      // holds the pending debounce timer; `_lineGen` is a monotonically
      // increasing request-generation counter so a stale /cart/change.js
      // response can be ignored if the user has clicked again since it
      // fired.
      this._lineDebounce = {};
      this._lineGen = {};
      this._queue = Promise.resolve();
      this.QTY_DEBOUNCE_MS = 300;
      this.focusTrapEnabled =
        root.getAttribute('data-focus-trap') !== 'false';

      this.onKeyDown = this.onKeyDown.bind(this);
      this.onRootClick = this.onRootClick.bind(this);
      this.onBackdropClick = this.onBackdropClick.bind(this);
      this.onCartToggle = this.onCartToggle.bind(this);
      this.onCartOpen = this.onCartOpen.bind(this);
      this.onCartClose = this.onCartClose.bind(this);
      this.onCartUpdated = this.onCartUpdated.bind(this);
      this.onFormSubmit = this.onFormSubmit.bind(this);

      this.bindEvents();
    }

    CartDrawer.prototype.bindEvents = function () {
      this.root.addEventListener('click', this.onRootClick);
      if (this.backdrop) {
        this.backdrop.addEventListener('click', this.onBackdropClick);
      }
      document.addEventListener('cart:toggle', this.onCartToggle);
      document.addEventListener('cart:open', this.onCartOpen);
      document.addEventListener('cart:close', this.onCartClose);
      document.addEventListener('cart:updated', this.onCartUpdated);
      document.addEventListener('submit', this.onFormSubmit, true);
    };

    /* External add-to-cart sources (product-card quick-add, PDP product-form,
       cart-upsells, etc.) POST to /cart/add.js themselves and dispatch
       `cart:updated` on document. Listen for that event, refresh the drawer
       markup from /cart?section_id=cart-drawer, then open. Skip when the
       event was self-dispatched (the in-drawer add/upsell flows already
       refresh + open synchronously) to avoid a double-fetch. */
    CartDrawer.prototype.onCartUpdated = function (event) {
      if (event && event.detail && event.detail.source === 'cart-drawer-internal') return;
      var self = this;
      self.refresh().then(function () { self.open(); }).catch(function () { self.open(); });
    };

    CartDrawer.prototype.onCartToggle = function () {
      this.toggle();
    };

    CartDrawer.prototype.onCartOpen = function () {
      this.open();
    };

    CartDrawer.prototype.onCartClose = function () {
      this.close();
    };

    CartDrawer.prototype.onRootClick = function (event) {
      var closeBtn = event.target.closest('[data-cart-drawer-close]');
      if (closeBtn) {
        event.preventDefault();
        this.close();
        return;
      }

      var qtyBtn = event.target.closest('[data-cart-qty-change]');
      if (qtyBtn) {
        event.preventDefault();
        this.handleQuantityChange(qtyBtn);
        return;
      }

      var removeBtn = event.target.closest('[data-cart-line-remove]');
      if (removeBtn) {
        event.preventDefault();
        this.handleRemove(removeBtn);
        return;
      }

      var upsellAddBtn = event.target.closest('[data-cart-upsell-add]');
      if (upsellAddBtn) {
        event.preventDefault();
        this.handleUpsellAdd(upsellAddBtn);
        return;
      }
    };

    CartDrawer.prototype.handleUpsellAdd = function (btn) {
      if (btn.hasAttribute('disabled')) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var self = this;
      var root = btn.closest('[data-cart-upsells-root]');

      function setLive(message) {
        if (!root) return;
        var live = root.querySelector('[data-cart-upsells-live]');
        if (live) live.textContent = message || '';
      }

      // Optimistic chip state so the click feels instant (mirrors the
      // line-item `data-line-busy` pattern). Cleared on completion in
      // every branch below.
      btn.setAttribute('disabled', '');
      btn.setAttribute('data-adding', 'true');

      function clearAddingState() {
        btn.removeAttribute('disabled');
        btn.removeAttribute('data-adding');
      }

      // Single /cart/add.js call. On success we re-render the drawer
      // body once via refresh() so the new line appears, then read the
      // fresh count straight from the re-rendered DOM -- no redundant
      // /cart.js round-trip before the refresh (QA-04 speed fix).
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }]
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            setLive('Could not add to cart. Please try again.');
            clearAddingState();
            return;
          }
          setLive('Added to cart');
          // Klaviyo "Added to Cart" (#58). result.data is the /cart/add.js
          // response ({ items: [...] } for this JSON POST).
          if (window.RTLKlaviyo) window.RTLKlaviyo.trackAddedToCart(result.data);
          // Algolia "Added to cart after search" (#341). No-ops unless the
          // product was opened from search results. `1` is the quantity
          // posted above: the response's `quantity` is the line's new total.
          if (window.RTLAlgoliaInsights) window.RTLAlgoliaInsights.trackAddedToCart(result.data, 1);
          return self.refresh().then(function () {
            var countEl = self.root.querySelector('[data-cart-drawer-count]');
            var count = countEl ? parseInt(countEl.textContent, 10) : 0;
            if (isNaN(count)) count = 0;
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: { item_count: count, source: 'cart-drawer-internal' }
              })
            );
            // The chip's host card is replaced by the refresh innerHTML
            // swap, so clearing its state is a no-op in the common path;
            // call it anyway to cover the case where the same card
            // survives (product still in the upsell rail).
            clearAddingState();
            self.open();
          });
        })
        .catch(function () {
          setLive('Could not add to cart. Please try again.');
          clearAddingState();
        });
    };

    CartDrawer.prototype.onBackdropClick = function () {
      this.close();
    };

    CartDrawer.prototype.toggle = function () {
      if (this.isOpen) this.close();
      else this.open();
    };

    CartDrawer.prototype.open = function () {
      if (this.isOpen) return;
      this.isOpen = true;

      this.previousFocus =
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;

      if (this.backdrop) {
        this.backdrop.removeAttribute('hidden');
        // Force reflow so opacity transition runs.
        void this.backdrop.offsetWidth;
        this.backdrop.classList.add('is-visible');
      }

      this.root.removeAttribute('inert');
      this.root.setAttribute('aria-hidden', 'false');
      this.root.setAttribute('aria-modal', 'true');
      this.root.classList.add('is-open');
      document.documentElement.classList.add('cart-drawer-open');

      this.setTriggerExpanded(true);

      document.addEventListener('keydown', this.onKeyDown);

      var self = this;
      window.requestAnimationFrame(function () {
        var firstFocusable = self.root.querySelector(FOCUSABLE_SELECTOR);
        if (firstFocusable) {
          try { firstFocusable.focus(); } catch (e) { /* noop */ }
        } else {
          try { self.root.focus(); } catch (e) { /* noop */ }
        }
      });
    };

    CartDrawer.prototype.close = function () {
      if (!this.isOpen) return;
      this.isOpen = false;

      this.root.classList.remove('is-open');
      this.root.setAttribute('aria-hidden', 'true');
      this.root.setAttribute('aria-modal', 'false');
      this.root.setAttribute('inert', '');
      document.documentElement.classList.remove('cart-drawer-open');

      if (this.backdrop) {
        this.backdrop.classList.remove('is-visible');
        var bd = this.backdrop;
        window.setTimeout(function () {
          if (!bd.classList.contains('is-visible')) {
            bd.setAttribute('hidden', '');
          }
        }, 320);
      }

      this.setTriggerExpanded(false);

      document.removeEventListener('keydown', this.onKeyDown);

      var prev = this.previousFocus;
      this.previousFocus = null;
      window.requestAnimationFrame(function () {
        if (prev && typeof prev.focus === 'function') {
          try { prev.focus(); } catch (e) { /* noop */ }
        }
      });
    };

    CartDrawer.prototype.setTriggerExpanded = function (open) {
      var triggers = document.querySelectorAll('[data-cart-toggle]');
      for (var i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    };

    CartDrawer.prototype.onKeyDown = function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      if (!this.focusTrapEnabled) return;

      var focusables = Array.prototype.slice
        .call(this.root.querySelectorAll(FOCUSABLE_SELECTOR))
        .filter(function (el) {
          return !el.hasAttribute('disabled') && el.offsetParent !== null;
        });
      if (focusables.length === 0) return;

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        try { last.focus(); } catch (e) { /* noop */ }
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        try { first.focus(); } catch (e) { /* noop */ }
      }
    };

    // ----------------------------------------------------------------
    // AJAX cart operations.
    // ----------------------------------------------------------------

    CartDrawer.prototype.setUpdating = function (flag) {
      this.isUpdating = flag;
      if (flag) {
        this.root.setAttribute('data-updating', 'true');
      } else {
        this.root.removeAttribute('data-updating');
      }
      var buttons = this.root.querySelectorAll(
        '[data-cart-qty-change], [data-cart-line-remove]'
      );
      for (var i = 0; i < buttons.length; i++) {
        if (flag) buttons[i].setAttribute('disabled', '');
        else buttons[i].removeAttribute('disabled');
      }
    };

    CartDrawer.prototype.showError = function (message) {
      var errEl = this.root.querySelector('[data-cart-error]');
      if (!errEl) return;
      errEl.textContent = message || 'Something went wrong updating your cart.';
      errEl.removeAttribute('hidden');
    };

    CartDrawer.prototype.clearError = function () {
      var errEl = this.root.querySelector('[data-cart-error]');
      if (!errEl) return;
      errEl.textContent = '';
      errEl.setAttribute('hidden', '');
    };

    CartDrawer.prototype.handleQuantityChange = function (btn) {
      // #218: optimistic + debounced per-row updates. The row stays
      // interactive while a call is in flight -- consecutive clicks
      // accumulate against the CURRENTLY DISPLAYED value (so three quick
      // +1 clicks resolve to +3 in one coalesced server call) and the
      // debounce timer (keyed by the stable line key) is reset each
      // click. No early-return on a busy row -- that is the bug we fix.
      var lineEl = btn.closest('[data-cart-drawer-line]');
      if (!lineEl) return;
      var delta = parseInt(btn.getAttribute('data-delta'), 10);
      if (isNaN(delta)) return;

      var valueEl = lineEl.querySelector('[data-cart-qty-value]');
      var current = valueEl ? parseInt(valueEl.textContent, 10) : NaN;
      if (isNaN(current)) return;

      // A row already on its way out ignores further steps -- another
      // zero would remove whichever line slides into its index next.
      if (lineEl.getAttribute('data-line-removing') === 'true') return;

      var next = current + delta;

      // Stepping down to zero IS a removal: route it through the same
      // immediate path as the X so the row leaves the drawer.
      if (next <= 0) {
        this.removeLine(lineEl);
        return;
      }

      this.clearError();

      // Optimistic value write -- instant feedback, no wait on the
      // server round-trip.
      if (valueEl) valueEl.textContent = String(next);

      this.scheduleLineChange(lineEl, next);
    };

    CartDrawer.prototype.handleRemove = function (btn) {
      var lineEl = btn.closest('[data-cart-drawer-line]');
      if (!lineEl) return;
      this.removeLine(lineEl);
    };

    // Removal feels best when immediate -- bypass the debounce and fire
    // straight away (quantity 0). If a qty debounce is pending on this same
    // row, cancel it -- the row is going away. The row is flagged as
    // removing (dimmed, inert) so a second X / minus can't queue another
    // zero against the line index the NEXT item inherits.
    CartDrawer.prototype.removeLine = function (lineEl) {
      if (lineEl.getAttribute('data-line-removing') === 'true') return;
      var lineKey = lineEl.getAttribute('data-line-key');
      if (lineKey && this._lineDebounce[lineKey]) {
        clearTimeout(this._lineDebounce[lineKey]);
        delete this._lineDebounce[lineKey];
      }
      lineEl.setAttribute('data-line-removing', 'true');
      this.clearError();
      this.dispatchLineChange(lineEl, 0);
    };

    // Runs cart mutations one at a time. Each request targets a 1-based
    // line INDEX, and a removal shifts every later index down by one -- so
    // a call may only resolve its index once every earlier call has landed
    // and been patched into the DOM. Rejections are swallowed on the chain
    // so one failed call can't wedge the queue.
    CartDrawer.prototype.enqueue = function (task) {
      var run = this._queue.then(task, task);
      this._queue = run.catch(function () {});
      return run;
    };

    CartDrawer.prototype.findLine = function (lineKey) {
      return this.root.querySelector('[data-cart-drawer-line][data-line-key="' + lineKey + '"]');
    };

    // Reset/restart the per-line debounce timer. Keyed by the stable
    // data-line-key so debouncing line A never cancels a pending call
    // on line B, and a removal-driven re-index of data-line cannot
    // mis-target the timer.
    CartDrawer.prototype.scheduleLineChange = function (lineEl, quantity) {
      var self = this;
      var lineKey = lineEl.getAttribute('data-line-key');
      if (!lineKey) {
        // No stable key -- fall back to firing immediately.
        this.dispatchLineChange(lineEl, quantity);
        return;
      }

      // Show the confined per-row spinner while a call is queued/in-flight.
      lineEl.setAttribute('data-line-syncing', 'true');
      var statusEl = lineEl.querySelector('[data-cart-line-status]');
      if (statusEl) statusEl.textContent = statusEl.getAttribute('data-sync-label') || '';

      if (this._lineDebounce[lineKey]) clearTimeout(this._lineDebounce[lineKey]);
      this._lineDebounce[lineKey] = setTimeout(function () {
        delete self._lineDebounce[lineKey];
        self.dispatchLineChange(lineEl, quantity);
      }, this.QTY_DEBOUNCE_MS);
    };

    // Queue a single /cart/change.js call for a line, guarded by a
    // per-line request-generation counter so a stale response can never
    // clobber a newer optimistic value.
    CartDrawer.prototype.dispatchLineChange = function (lineEl, quantity) {
      var self = this;
      var lineKey = lineEl.getAttribute('data-line-key');

      // Bump the generation for this line; only a response carrying the
      // current generation is allowed to write qty back.
      var gen = (this._lineGen[lineKey] || 0) + 1;
      this._lineGen[lineKey] = gen;

      lineEl.setAttribute('data-line-syncing', 'true');

      return this.enqueue(function () {
        // Re-find the row and resolve its 1-based server line number only
        // NOW, once every earlier call has been patched in -- a removal
        // ahead of us in the queue re-indexes data-line-index. A row that a
        // refresh() has since replaced is gone; its change is dropped.
        var row = self.findLine(lineKey);
        if (!row) return;
        var line = parseInt(row.getAttribute('data-line-index'), 10);
        if (isNaN(line)) return;

        return self.postLineChange(row, lineKey, line, quantity, gen);
      });
    };

    CartDrawer.prototype.postLineChange = function (row, lineKey, line, quantity, gen) {
      var self = this;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (response) {
          return response
            .json()
            .then(function (data) {
              return { ok: response.ok, data: data };
            });
        })
        .then(function (result) {
          var isStale = self._lineGen[lineKey] !== gen;

          if (!result.ok) {
            row.removeAttribute('data-line-removing');
            self.clearLineSync(lineKey);
            self.showError(
              (result.data && result.data.description) ||
                'Could not update item.'
            );
            // Reconcile the displayed qty back to the server's truth so
            // the optimistic value does not stick after a rejected change.
            // The pending-timer guard inside patchFromCart still applies,
            // so a row mid-edit keeps its newer optimistic value.
            if (result.data && typeof result.data === 'object' && result.data.items) {
              return self.patchFromCart(result.data);
            }
            return self.refresh();
          }

          var cart = result.data || {};
          var count = typeof cart.item_count === 'number' ? cart.item_count : 0;

          // The server has dropped this line, so drop its row before the
          // positional patch below -- otherwise every later row would be
          // patched with its neighbour's data and the LAST row would be
          // the one deleted.
          if (quantity === 0 && row.parentNode) {
            row.parentNode.removeChild(row);
          }

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { item_count: count, source: 'cart-drawer-internal' }
            })
          );

          // Only clear this line's sync affordance if no newer call is
          // pending/in-flight for it.
          if (!isStale && !self._lineDebounce[lineKey]) {
            self.clearLineSync(lineKey);
          }

          // QA round 2 item 1k: in-place patch instead of re-rendering
          // the drawer body. `/cart/change.js` returns the full cart, so
          // patch from it. #218: patchFromCart leaves any line with a live
          // pending edit alone. Returned so the queue waits on any
          // structural refresh() it falls back to.
          return self.patchFromCart(cart);
        })
        .catch(function () {
          row.removeAttribute('data-line-removing');
          self.clearLineSync(lineKey);
          self.showError('Network error -- please try again.');
          // Network failure: re-render the drawer body from the server so
          // the row reverts from the optimistic value to the cart's
          // actual quantity. refresh() is the structural restore path.
          return self.refresh();
        });
    };

    // Clear the per-row sync spinner + live region for a line key.
    CartDrawer.prototype.clearLineSync = function (lineKey) {
      var row = this.root.querySelector('[data-cart-drawer-line][data-line-key="' + lineKey + '"]');
      if (!row) return;
      row.removeAttribute('data-line-syncing');
      var statusEl = row.querySelector('[data-cart-line-status]');
      if (statusEl) statusEl.textContent = '';
    };

    // ----------------------------------------------------------------
    // In-place cart patch (QA r2 1k).
    // Updates header count, shipping bar, line prices/qtys, footer
    // subtotal from a `/cart/change.js` response object -- without
    // re-rendering the drawer body. Falls back to `refresh()` only if
    // the shape of the cart materially changed (bundle discount on/off,
    // or items appearing/disappearing in a way we can't safely patch).
    // ----------------------------------------------------------------
    CartDrawer.prototype.patchFromCart = function (cart) {
      if (!cart || typeof cart !== 'object') return;
      var self = this;

      // Header count.
      var countEl = self.root.querySelector('[data-cart-drawer-count]');
      if (countEl) countEl.textContent = String(cart.item_count || 0);

      // Empty state vs lines container.
      if ((cart.item_count || 0) === 0) {
        // Hide footer, swap lines for empty state. This is a structural
        // change so let refresh() handle it -- worth the round-trip.
        return self.refresh();
      }

      // Discount appeared/disappeared guard. When a line-level discount
      // toggles (e.g. a qty-triggered bundle discount), the footer switches
      // between its 1-row (subtotal only) and 3-row (subtotal/discount/total)
      // layout AND each line's strikethrough appears/disappears. In-place
      // patching can only rewrite existing nodes, never add/remove them, so
      // a full server re-render is the correct path in that case. The
      // rendered footer only carries [data-cart-drawer-discount] when a
      // discount was present at render time, so its presence is a faithful
      // proxy for "was a discount showing".
      var footerHasDiscountRow = !!self.root.querySelector('[data-cart-drawer-discount]');
      var cartHasDiscount =
        typeof cart.original_total_price === 'number' &&
        typeof cart.total_price === 'number' &&
        cart.original_total_price > cart.total_price;
      if (footerHasDiscountRow !== cartHasDiscount) {
        return self.refresh();
      }

      // Row-count guard. Positional reconciliation (below) is only sound
      // when every rendered row still has exactly one cart line. The
      // removal path drops its own row before calling in, so a mismatch
      // here means the cart's shape changed some other way (a line added
      // or merged server-side, a stale tab) -- re-render rather than
      // patch rows with their neighbours' data.
      var lineEls = self.root.querySelectorAll('[data-cart-drawer-line]');
      var items = Array.isArray(cart.items) ? cart.items : [];
      if (lineEls.length !== items.length) {
        return self.refresh();
      }

      // Footer subtotal / discount totals.
      var subEl = self.root.querySelector('[data-cart-drawer-subtotal]');
      if (subEl) subEl.textContent = self.formatMoney(cart.total_price);
      var origEl = self.root.querySelector('[data-cart-drawer-original-total]');
      if (origEl && typeof cart.original_total_price === 'number') {
        origEl.textContent = self.formatMoney(cart.original_total_price);
      }
      var discEl = self.root.querySelector('[data-cart-drawer-discount]');
      if (discEl && typeof cart.original_total_price === 'number') {
        // Render the discount as a leading-minus then a positive amount
        // ("-$20.70"), not money_with_currency on a negative ("$-20.70").
        discEl.textContent = '-' + self.formatMoney(cart.original_total_price - cart.total_price);
      }
      // BNPL line: a quarter of the total, without the currency symbol (the
      // translation string carries its own `$`). Mirrors the Liquid half's
      // `divided_by: 4.0 | money_without_currency`.
      var bnplEl = self.root.querySelector('[data-cart-drawer-bnpl-amount]');
      if (bnplEl && typeof cart.total_price === 'number') {
        bnplEl.textContent = self.formatAmount(cart.total_price / 4);
      }

      // Per-line qty + price patch. Lines come back in cart.items in
      // the same order as rendered, indexed 1..n. Reconcile POSITIONALLY
      // (row i <-> items[i]), never by line-item `key`: the Shopify Ajax
      // Cart API documents the key as NON-persistent -- /cart/change.js
      // re-hashes the changed line's key, so a key match would miss on a
      // successful change and wrongly delete the still-in-cart row (#227).
      // The request already targets the server by 1-based `data-line-index`
      // and the response items come back in that same order, so position
      // is the stable handle.
      for (var i = 0; i < items.length; i++) {
        var el = lineEls[i];
        var match = items[i];
        // Stable per-row identity for the debounce guard. The rendered
        // data-line-key (the Liquid item.key, same as the /cart.js key) is
        // stable for the life of the DOM row between server re-renders, so
        // the guard map (populated in scheduleLineChange off this same
        // attribute) continues to work keyed off it. We deliberately do NOT
        // use the /cart/change.js response key here -- that is volatile.
        var key = el.getAttribute('data-line-key');
        var qtyEl = el.querySelector('[data-cart-qty-value]');
        // #218 stale-response guard: do NOT overwrite the displayed qty
        // for a row that has a pending debounce timer -- the user has
        // clicked again since this response's request fired, so the DOM
        // holds a newer optimistic value the server hasn't seen yet.
        // Prices/compare are always safe to refresh (they reflect the
        // server's confirmed state and will re-patch on the next call).
        if (qtyEl && !self._lineDebounce[key]) {
          qtyEl.textContent = String(match.quantity);
        }
        // Current price is always the amount actually paid for the line
        // (final_line_price folds in any allocated line-level discount).
        var priceEl = el.querySelector('[data-cart-line-price-current]');
        if (priceEl) priceEl.textContent = self.formatMoney(match.final_line_price);
        var compareEl = el.querySelector('[data-cart-line-price-compare]');
        if (compareEl) {
          // A live line discount strikes the pre-discount line price;
          // otherwise fall back to the compare-at (RRP) reference stored on
          // the element at render time. (The Ajax line item carries no
          // compare_at_price, so the RRP unit value lives in the data attr.)
          if (match.original_line_price > match.final_line_price) {
            compareEl.textContent = self.formatMoney(match.original_line_price);
          } else {
            var unitCompare = parseInt(compareEl.getAttribute('data-unit-compare-cents'), 10);
            if (!isNaN(unitCompare) && unitCompare > 0) {
              compareEl.textContent = self.formatMoney(unitCompare * match.quantity);
            }
          }
        }
      }
      // Re-index remaining lines so `data-line` / `data-line-index`
      // stay aligned with the cart line numbers (1-based) -- otherwise
      // the next change.js call after a removal will target the wrong
      // line on the server. Update both the wrapper and qty buttons.
      var remaining = self.root.querySelectorAll('[data-cart-drawer-line]');
      for (var n = 0; n < remaining.length; n++) {
        var newIndex = String(n + 1);
        remaining[n].setAttribute('data-line-index', newIndex);
        var btns = remaining[n].querySelectorAll('[data-cart-qty-change], [data-cart-line-remove]');
        for (var b = 0; b < btns.length; b++) {
          btns[b].setAttribute('data-line', newIndex);
        }
      }

      // Free-shipping bar progress + copy.
      self.patchShippingBar(cart);

      // Footer hidden toggle.
      var footer = self.root.querySelector('[data-cart-drawer-footer]');
      if (footer) {
        if ((cart.item_count || 0) === 0) footer.setAttribute('hidden', '');
        else footer.removeAttribute('hidden');
      }
    };

    // Repaints the single shipping progress track from the cart JSON returned
    // by /cart/change.js, so the bar tracks quantity edits without a section
    // re-fetch. Each milestone node carries its own threshold (cents), its
    // segment bounds on the track, and the raw un-substituted copy templates
    // in data attributes -- see `snippets/shipping-progress.liquid`, which is
    // the server-render half of this and must stay in step with the maths
    // below.
    CartDrawer.prototype.patchShippingBar = function (cart) {
      var total = typeof cart.total_price === 'number' ? cart.total_price : 0;
      var roots = this.root.querySelectorAll('[data-shipping-progress]');

      for (var r = 0; r < roots.length; r++) {
        var root = roots[r];
        var nodes = root.querySelectorAll('[data-shipping-node]');
        if (!nodes.length) continue;

        var fill = 100;
        var resolved = '';
        var targetFound = false;
        var moneyFormat = this.shippingMoneyFormat(root);

        for (var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          var threshold = parseInt(node.getAttribute('data-threshold'), 10) || 0;
          var prevThreshold = parseInt(node.getAttribute('data-prev-threshold'), 10) || 0;
          var stop = parseInt(node.getAttribute('data-stop'), 10) || 0;
          var prevStop = parseInt(node.getAttribute('data-prev-stop'), 10) || 0;

          if (total >= threshold) node.classList.add('is-unlocked');
          else node.classList.remove('is-unlocked');

          // The first node the cart hasn't reached owns both the fill
          // interpolation and the copy line -- everything past it is still
          // locked and everything before it is already ticked.
          if (!targetFound && total < threshold) {
            targetFound = true;

            var range = threshold - prevThreshold;
            var span = stop - prevStop;
            // `Math.floor`, not `Math.round` -- Liquid's `divided_by` on two
            // integers floors, so rounding here would drift the patched width
            // a percentage point away from the server render on the refresh
            // path.
            var within = range > 0 ? Math.floor(((total - prevThreshold) * span) / range) : 0;
            fill = Math.min(100, Math.max(0, prevStop + within));

            resolved = this.resolveShippingCopy(
              node.getAttribute('data-message'),
              threshold - total,
              node.getAttribute('data-threshold-display'),
              moneyFormat
            );
          }
        }

        if (!targetFound) {
          var last = nodes[nodes.length - 1];
          fill = 100;
          resolved = this.resolveShippingCopy(
            last.getAttribute('data-unlocked'),
            0,
            last.getAttribute('data-threshold-display'),
            moneyFormat
          );
        }

        var bar = root.querySelector('[data-shipping-bar]');
        if (bar) bar.style.width = fill + '%';

        var copy = root.querySelector('[data-shipping-copy]');
        if (copy) {
          copy.innerHTML = '<span>' + resolved + '</span>';
          this.announceShipping(copy.textContent);
        }
      }
    };

    // Mirrors the visible copy into the persistent live region. The bar's own
    // markup deliberately carries no `aria-live` -- refresh() replaces the
    // header region wholesale, and a live region that appears together with
    // its content is never announced. Routing both update paths through here
    // means the quantity path and the add-to-cart path announce identically.
    CartDrawer.prototype.announceShipping = function (text) {
      var target = this.shippingAnnounce;
      if (!target) return;
      var next = String(text || '').replace(/\s+/g, ' ').trim();
      // Re-writing the same sentence would re-announce it on every cart
      // event, so only a genuine change is pushed.
      if (next === target.textContent) return;
      target.textContent = next;
    };

    // Reads the announcement out of the freshly server-rendered bar. Used on
    // the refresh() path, where the copy is replaced rather than patched.
    CartDrawer.prototype.announceShippingFromDom = function () {
      var copy = this.root.querySelector('[data-shipping-progress] [data-shipping-copy]');
      this.announceShipping(copy ? copy.textContent : '');
    };

    // Substitutes the `[amount]` / `[threshold]` tokens the merchant copy
    // carries. Must land on byte-identical output to the Liquid half
    // (`snippets/shipping-progress.liquid`), which resolves `[amount]` with
    // `money_without_currency | replace_last: '.00', ''` and `[threshold]`
    // with `round: 0`. The threshold arrives pre-rounded in
    // `data-threshold-display`; the amount is formatted below.
    CartDrawer.prototype.resolveShippingCopy = function (template, remainingCents, thresholdDisplay, moneyFormat) {
      return (template || '')
        .split('[amount]').join(this.formatShippingAmount(remainingCents, moneyFormat))
        .split('[threshold]').join(thresholdDisplay || '');
    };

    // Derives this store's grouping and decimal separators from the sample
    // the snippet renders through `money_without_currency` itself
    // (`data-amount-format`), rather than hardcoding `1,234.56`. The sample is
    // `123456789` cents, so every digit is distinct and the separators fall
    // straight out of the string. Cached on the element -- it can't change
    // without a re-render.
    CartDrawer.prototype.shippingMoneyFormat = function (root) {
      if (root.__shippingMoneyFormat) return root.__shippingMoneyFormat;
      var sample = root.getAttribute('data-amount-format') || '1,234,567.89';
      var separators = sample.replace(/\d/g, '');
      var group = separators.charAt(0) || ',';
      var last = separators.charAt(separators.length - 1) || '.';
      var tail = sample.split(last).pop();
      // A three-digit tail behind the SAME character that groups thousands is
      // another group, not a fraction -- that's a zero-decimal currency (JPY).
      var decimals = last === group && tail.length === 3 ? 0 : tail.length;
      var format = {
        group: group,
        decimal: decimals > 0 ? last : '',
        decimals: decimals
      };
      root.__shippingMoneyFormat = format;
      return format;
    };

    CartDrawer.prototype.formatShippingAmount = function (cents, moneyFormat) {
      var fmt = moneyFormat || { group: ',', decimal: '.', decimals: 2 };
      var n = Math.max(0, Number(cents) || 0);
      var parts = (n / 100).toFixed(fmt.decimals).split('.');
      var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.group);
      if (fmt.decimals) formatted += fmt.decimal + parts[1];
      // Apply the Liquid half's `replace_last: '.00', ''` LITERALLY, as the
      // same string operation on the same string, rather than reimplementing
      // what it means. That way the two halves agree by construction --
      // including where the filter is imprecise (under a money format that
      // groups with `.`, `1.000,00` loses a group rather than a fraction;
      // both halves now do that identically instead of drifting apart).
      var tail = formatted.lastIndexOf('.00');
      if (tail === -1) return formatted;
      return formatted.slice(0, tail) + formatted.slice(tail + 3);
    };

    // This store's separators for the non-shipping money paths (footer
    // totals, BNPL), read from the SAME `data-amount-format` sample the
    // shipping bar renders rather than assuming `1,234.56` a second time.
    // The bar is absent when both tiers are disabled, so fall back then --
    // and only cache once a real sample has been seen, since refresh() can
    // bring the bar in after an empty-cart first paint.
    CartDrawer.prototype.amountFormat = function () {
      if (this.__amountFormat) return this.__amountFormat;
      var sampleEl = this.root.querySelector('[data-shipping-progress][data-amount-format]');
      if (!sampleEl) return { group: ',', decimal: '.', decimals: 2 };
      this.__amountFormat = this.shippingMoneyFormat(sampleEl);
      return this.__amountFormat;
    };

    // `1,234.50` from cents -- the `money_without_currency` shape.
    CartDrawer.prototype.formatAmount = function (cents, decimals) {
      var fmt = this.amountFormat();
      var n = Math.max(0, Number(cents) || 0);
      var places = typeof decimals === 'number' ? decimals : fmt.decimals;
      var parts = (n / 100).toFixed(places).split('.');
      var formatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, fmt.group);
      if (places > 0) formatted += (fmt.decimal || '.') + parts[1];
      return formatted;
    };

    CartDrawer.prototype.formatMoney = function (cents) {
      // Mirror Shopify's `money` filter without pulling in the full
      // money-format parser. The root carries `shop.money_format`
      // (dollar sign + amount on both AU and US), so no currency code is
      // added.
      var n = Number(cents) || 0;
      // Money format template uses Shopify's tokenised placeholders --
      // built as a string at runtime so Theme Check doesn't flag them
      // as Liquid output inside the static JS tag.
      var open = '{' + '{';
      var close = '}' + '}';
      var defaultFmt = '$' + open + 'amount' + close;
      var fmt = this.root.getAttribute('data-money-format') || defaultFmt;
      // Tokens supported: `amount` (with decimals) and
      // `amount_no_decimals`.
      var amountToken = new RegExp('\\$?\\{\\{\\s*amount\\s*\\}\\}');
      var amountNoDecToken = new RegExp('\\$?\\{\\{\\s*amount_no_decimals\\s*\\}\\}');
      return fmt
        .replace(amountToken, '$' + this.formatAmount(n))
        .replace(amountNoDecToken, '$' + this.formatAmount(n, 0));
    };

    CartDrawer.prototype.refresh = function () {
      var self = this;
      // #218: a full body re-render wipes the rows the per-line debounce
      // timers point at. Cancel any pending timers and reset the
      // generation counters so a stale timer can't fire against the
      // rebuilt DOM (the fresh markup carries the server-truth quantities).
      for (var dk in this._lineDebounce) {
        if (Object.prototype.hasOwnProperty.call(this._lineDebounce, dk)) {
          clearTimeout(this._lineDebounce[dk]);
        }
      }
      this._lineDebounce = {};
      this._lineGen = {};
      return fetch('/cart?section_id=cart-drawer', {
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('refresh failed');
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var regions = ['header', 'body', 'footer'];
          for (var i = 0; i < regions.length; i++) {
            var sel = '[data-cart-drawer-' + regions[i] + ']';
            var next = doc.querySelector(sel);
            var current = self.root.querySelector(sel);
            if (next && current) {
              current.innerHTML = next.innerHTML;
              // Footer hidden attribute may have toggled.
              if (next.hasAttribute('hidden')) {
                current.setAttribute('hidden', '');
              } else {
                current.removeAttribute('hidden');
              }
            }
          }
          // The header swap replaced the shipping bar wholesale, so push its
          // new copy into the persistent live region by hand.
          self.announceShippingFromDom();
        })
        .catch(function () {
          /* swallow -- refresh is best-effort */
        });
    };

    // ----------------------------------------------------------------
    // Add-to-cart interception.
    // Listens globally for `form[action$="/cart/add"]` submissions.
    // ----------------------------------------------------------------
    CartDrawer.prototype.onFormSubmit = function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (!/\/cart\/add\b/.test(action)) return;
      // Skip if form opts out (e.g. PDP wants its own handler).
      if (form.hasAttribute('data-no-cart-drawer')) return;

      event.preventDefault();
      var self = this;
      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            self.showError(
              (result.data && result.data.description) ||
                'Could not add item to cart.'
            );
            self.open();
            return;
          }
          // Klaviyo "Added to Cart" (#58). result.data is the /cart/add.js
          // response (single line-item object for this form-encoded POST).
          if (window.RTLKlaviyo) window.RTLKlaviyo.trackAddedToCart(result.data);
          // Algolia "Added to cart after search" (#341). No-ops unless the
          // product was opened from search results. Passes the form's
          // quantity (Shopify's default of 1 when the form has none): the
          // response's `quantity` is the line's new total.
          if (window.RTLAlgoliaInsights) {
            window.RTLAlgoliaInsights.trackAddedToCart(result.data, formData.get('quantity'));
          }
          // Pull current count from /cart.js for an accurate badge update.
          return fetch('/cart.js', {
            headers: { Accept: 'application/json' }
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var count =
                cart && typeof cart.item_count === 'number'
                  ? cart.item_count
                  : 0;
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: { item_count: count, source: 'cart-drawer-internal' }
                })
              );
              return self.refresh();
            })
            .then(function () {
              self.open();
            });
        })
        .catch(function () {
          self.showError('Network error -- please try again.');
        });
    };

    // ----------------------------------------------------------------
    // Boot.
    // ----------------------------------------------------------------
    function init() {
      var root = findRoot();
      if (!root || root.__cartDrawerController) return;
      var controller = new CartDrawer(root);
      root.__cartDrawerController = controller;

      window.cartBus = {
        open: function () { controller.open(); },
        close: function () { controller.close(); },
        toggle: function () { controller.toggle(); },
        refresh: function () { return controller.refresh(); }
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      if (section && section.querySelector && section.querySelector('[data-cart-drawer]')) {
        // Reset the singleton so the new DOM is picked up.
        var prev = document.querySelector('[data-cart-drawer]');
        if (prev) prev.__cartDrawerController = null;
        init();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-carousel"] && !Shopify.designMode) return;
  try {
    
  /* Feature carousel left-image sync. On desktop the LEFT half holds
     the active product's hero image; the carousel rail on the right
     advances through products. We watch the rail viewport's scroll
     position and flip `.is-active` on the matching image link to swap
     the editorial image when the slide changes. */
  (function () {
    'use strict';
    var SCROLL_TOLERANCE = 1;
    var initialized = new WeakSet();

    function getSlideStep(viewport) {
      var firstSlide = viewport.querySelector('.product-carousel__slide');
      if (!firstSlide) return viewport.clientWidth;
      var rect = firstSlide.getBoundingClientRect();
      var trackStyle = window.getComputedStyle(viewport.querySelector('.product-carousel__track'));
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      return Math.max(1, Math.round(rect.width + gap));
    }

    function syncActiveImage(section) {
      var viewport = section.querySelector('.product-carousel__viewport');
      var images = section.querySelectorAll('[data-fc-image-for]');
      if (!viewport || !images.length) return;
      var step = getSlideStep(viewport);
      var index = Math.max(0, Math.round(viewport.scrollLeft / step));
      Array.prototype.forEach.call(images, function (link) {
        var i = parseInt(link.getAttribute('data-fc-image-for'), 10);
        if (i === index) {
          link.classList.add('is-active');
          link.removeAttribute('aria-hidden');
          link.removeAttribute('tabindex');
        } else {
          link.classList.remove('is-active');
          link.setAttribute('aria-hidden', 'true');
          link.setAttribute('tabindex', '-1');
        }
      });
    }

    function initSection(section) {
      if (initialized.has(section)) return;
      initialized.add(section);
      var viewport = section.querySelector('.product-carousel__viewport');
      if (!viewport) return;

      var scrollFrame = null;
      viewport.addEventListener('scroll', function () {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function () {
          scrollFrame = null;
          syncActiveImage(section);
        });
      });

      window.requestAnimationFrame(function () {
        syncActiveImage(section);
      });
    }

    function initAll() {
      var sections = document.querySelectorAll('[data-feature-carousel]');
      Array.prototype.forEach.call(sections, initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var buttons = document.querySelectorAll('[data-footer-cookie-preferences]');
    if (!buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        // Guard against Shopify.customerPrivacy being undefined -- it is wired
        // by Epic 10 #62 via Shopify.loadFeatures(['consent-tracking-api']).
        // If it has not loaded yet, the click is a no-op rather than throwing.
        if (
          window.Shopify &&
          window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.openPrivacyModal === 'function'
        ) {
          window.Shopify.customerPrivacy.openPrivacyModal();
        }
      });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var SCROLL_THRESHOLD = 100;
    var DEFAULT_CLOSE_DELAY = 150;

    // ----------------------------------------------------------------
    // Mega-menu controller (#23) -- single-panel slide-out with
    // per-tab content switching.
    //
    // State per controller instance:
    //   activeTab    -- which top-level tab is open (null = closed)
    //   activeSub    -- which left-column sub-link is active (null = none)
    //   activeNested -- which nested item is active (null = none)
    //
    // Mirrors the headless HeaderNavigation + SlideoutNavigation model:
    // pointer-enter on a trigger with children opens the panel and sets
    // the active tab; pointer-leave schedules a close after the grace
    // delay; Esc closes immediately and restores focus to the trigger.
    // While the menu is open, `<html>` carries `.nav-open`.
    // ----------------------------------------------------------------
    function initMegaMenu(root) {
      var nav = root.querySelector('[data-mega-menu]');
      if (!nav) return;

      var triggers = Array.prototype.slice.call(
        nav.querySelectorAll('[data-mega-menu-trigger]')
      );
      if (triggers.length === 0) return;

      var container = nav.querySelector('[data-mega-menu-container]');
      if (!container) return;

      var panel = container.querySelector('[data-mega-menu-panel]');
      var hoverIndicator = nav.querySelector('[data-mega-menu-hover-indicator]');
      var triggerRow = nav.querySelector('[data-mega-menu-trigger-row]');

      var delayAttr = parseInt(nav.getAttribute('data-mega-menu-close-delay'), 10);
      var closeDelay = isNaN(delayAttr) ? DEFAULT_CLOSE_DELAY : delayAttr;

      var activeTab = null;
      var activeSub = null;
      var activeNested = null;
      var closeTimer = null;
      var lastTrigger = null;

      function clearCloseTimer() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
      }

      function getLeftUl(tabIndex) {
        return container.querySelector(
          '[data-mega-menu-tab="' + tabIndex + '"]'
        );
      }

      function getRightPane(tabIndex) {
        return container.querySelector(
          '[data-mega-menu-pane="' + tabIndex + '"]'
        );
      }

      function clearTabState() {
        // Wipe all `.is-active` on left uls + right panes + arrows + nested.
        var lefts = container.querySelectorAll('.mega-menu__left-items.is-active');
        for (var i = 0; i < lefts.length; i++) lefts[i].classList.remove('is-active');
        var panes = container.querySelectorAll('.mega-menu__right-pane.is-active');
        for (var j = 0; j < panes.length; j++) {
          panes[j].classList.remove('is-active');
          panes[j].classList.remove('has-nested');
        }
        clearSubState();
      }

      function clearSubState() {
        var subs = container.querySelectorAll('.mega-menu__left-item.is-active, .mega-menu__left-item.is-inactive');
        for (var i = 0; i < subs.length; i++) {
          subs[i].classList.remove('is-active');
          subs[i].classList.remove('is-inactive');
        }
        var arrows = container.querySelectorAll('.mega-menu__arrow.is-visible');
        for (var a = 0; a < arrows.length; a++) arrows[a].classList.remove('is-visible');
        var nestedUls = container.querySelectorAll('.mega-menu__nested-items.is-visible');
        for (var n = 0; n < nestedUls.length; n++) nestedUls[n].classList.remove('is-visible');
        var nestedWraps = container.querySelectorAll('.mega-menu__nested.has-children');
        for (var nw = 0; nw < nestedWraps.length; nw++) nestedWraps[nw].classList.remove('has-children');
        // Reset has-nested on the active pane.
        var activePane = container.querySelector('.mega-menu__right-pane.is-active');
        if (activePane) activePane.classList.remove('has-nested');
        activeSub = null;
        activeNested = null;
      }

      function updateHoverIndicator(triggerEl) {
        if (!hoverIndicator || !triggerRow) return;
        if (!triggerEl) {
          hoverIndicator.classList.remove('is-visible');
          return;
        }
        var rowRect = triggerRow.getBoundingClientRect();
        var trgRect = triggerEl.getBoundingClientRect();
        hoverIndicator.style.left = (trgRect.left - rowRect.left) + 'px';
        hoverIndicator.style.width = trgRect.width + 'px';
        hoverIndicator.classList.add('is-visible');
      }

      function setActiveTab(index) {
        clearCloseTimer();
        // Reset trigger aria-expanded on all triggers.
        for (var t = 0; t < triggers.length; t++) {
          triggers[t].setAttribute('aria-expanded', 'false');
        }

        if (index === null || index === undefined) {
          // Close.
          activeTab = null;
          clearTabState();
          container.classList.remove('is-visible');
          container.setAttribute('aria-hidden', 'true');
          container.setAttribute('hidden', '');
          if (panel) panel.removeAttribute('data-active-tab');
          document.documentElement.classList.remove('nav-open');
          updateHoverIndicator(null);
          return;
        }

        var trigger = triggers[index];
        if (!trigger) return;
        if (trigger.getAttribute('data-has-children') !== 'true') {
          // No panel for triggers without children -- close.
          setActiveTab(null);
          return;
        }

        var leftUl = getLeftUl(index);
        var pane = getRightPane(index);
        if (!leftUl && !pane) {
          setActiveTab(null);
          return;
        }

        // Reveal container, then activate the chosen tab.
        container.removeAttribute('hidden');
        container.removeAttribute('aria-hidden');
        // Force reflow before adding `.is-visible` so transitions trigger.
        // eslint-disable-next-line no-unused-expressions
        container.offsetHeight;
        container.classList.add('is-visible');
        document.documentElement.classList.add('nav-open');

        clearTabState();
        activeTab = index;
        lastTrigger = trigger;
        trigger.setAttribute('aria-expanded', 'true');
        if (panel) panel.setAttribute('data-active-tab', String(index));
        if (leftUl) leftUl.classList.add('is-active');
        if (pane) pane.classList.add('is-active');
        updateHoverIndicator(trigger);
      }

      function setActiveSub(subIndex) {
        if (activeTab === null) return;
        var leftUl = getLeftUl(activeTab);
        var pane = getRightPane(activeTab);
        if (!leftUl) return;

        // Reset sub state visually.
        var items = leftUl.querySelectorAll('.mega-menu__left-item');
        for (var i = 0; i < items.length; i++) {
          items[i].classList.remove('is-active');
          items[i].classList.remove('is-inactive');
          var arrow = items[i].querySelector('.mega-menu__arrow');
          if (arrow) arrow.classList.remove('is-visible');
        }

        // Reset nested visibility.
        if (pane) {
          var nestedUls = pane.querySelectorAll('.mega-menu__nested-items.is-visible');
          for (var n = 0; n < nestedUls.length; n++) nestedUls[n].classList.remove('is-visible');
          var nestedWrap = pane.querySelector('[data-mega-menu-nested]');
          if (nestedWrap) nestedWrap.classList.remove('has-children');
          pane.classList.remove('has-nested');
        }

        if (subIndex === null || subIndex === undefined) {
          activeSub = null;
          activeNested = null;
          return;
        }

        var target = leftUl.querySelector(
          '[data-mega-menu-sub="' + subIndex + '"]'
        );
        if (!target) return;
        activeSub = subIndex;
        activeNested = null;

        // Mark active + dim siblings.
        target.classList.add('is-active');
        var arrow2 = target.querySelector('.mega-menu__arrow');
        if (arrow2) arrow2.classList.add('is-visible');
        for (var s = 0; s < items.length; s++) {
          if (items[s] !== target) items[s].classList.add('is-inactive');
        }

        // Reveal nested ul if present; if so, dim the feature image.
        if (pane) {
          var nestedUl = pane.querySelector(
            '[data-mega-menu-nested-for="' + subIndex + '"]'
          );
          if (nestedUl) {
            nestedUl.classList.add('is-visible');
            var nestedWrap2 = pane.querySelector('[data-mega-menu-nested]');
            if (nestedWrap2) nestedWrap2.classList.add('has-children');
            pane.classList.add('has-nested');
          }
        }
      }

      function setActiveNested(nestedIndex) {
        // Lightweight active marker on the hovered nested item. Optional
        // visual; the hover fade for siblings is handled in pure CSS.
        if (activeTab === null) return;
        var pane = getRightPane(activeTab);
        if (!pane) return;
        var items = pane.querySelectorAll('.mega-menu__nested-item.is-active');
        for (var i = 0; i < items.length; i++) items[i].classList.remove('is-active');
        if (nestedIndex === null || nestedIndex === undefined) {
          activeNested = null;
          return;
        }
        // Find the nested li by index within the active nested ul.
        var nestedUl = pane.querySelector(
          '.mega-menu__nested-items.is-visible'
        );
        if (!nestedUl) return;
        var liNodes = nestedUl.querySelectorAll('.mega-menu__nested-item');
        if (nestedIndex < 0 || nestedIndex >= liNodes.length) return;
        activeNested = nestedIndex;
        liNodes[nestedIndex].classList.add('is-active');
      }

      function scheduleClose() {
        clearCloseTimer();
        closeTimer = setTimeout(function () {
          setActiveTab(null);
        }, closeDelay);
      }

      // -- Trigger row wiring ----------------------------------------
      triggers.forEach(function (trigger, index) {
        trigger.addEventListener('pointerenter', function () {
          clearCloseTimer();
          var hasChildren = trigger.getAttribute('data-has-children') === 'true';
          if (hasChildren) {
            setActiveTab(index);
          } else {
            setActiveTab(null);
            // Still show the hover underline for childless triggers.
            updateHoverIndicator(trigger);
          }
        });
        trigger.addEventListener('focus', function () {
          clearCloseTimer();
          var hasChildren = trigger.getAttribute('data-has-children') === 'true';
          if (hasChildren) {
            setActiveTab(index);
          } else {
            updateHoverIndicator(trigger);
          }
        });
        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            setActiveTab(null);
            return;
          }
          if (event.key === 'ArrowDown') {
            var hasChildren = trigger.getAttribute('data-has-children') === 'true';
            if (!hasChildren) return;
            event.preventDefault();
            setActiveTab(index);
            var leftUl = getLeftUl(index);
            if (!leftUl) return;
            var firstLink = leftUl.querySelector('a');
            if (firstLink) {
              firstLink.setAttribute('tabindex', '0');
              firstLink.focus();
            }
          }
        });
      });

      // Trigger row -- pointer leaving without entering the container
      // schedules a close; entering the container cancels it.
      if (triggerRow) {
        triggerRow.addEventListener('pointerleave', scheduleClose);
        triggerRow.addEventListener('pointerenter', clearCloseTimer);
      }

      // -- Container wiring ------------------------------------------
      container.addEventListener('pointerenter', clearCloseTimer);
      container.addEventListener('pointerleave', scheduleClose);

      // Backdrop click closes.
      var backdrop = container.querySelector('[data-mega-menu-backdrop]');
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          setActiveTab(null);
        });
      }

      // -- Per-sub hover wiring (left column) ------------------------
      var subItems = container.querySelectorAll('[data-mega-menu-sub]');
      for (var si = 0; si < subItems.length; si++) {
        (function (item) {
          var subIdx = parseInt(item.getAttribute('data-mega-menu-sub'), 10);
          item.addEventListener('pointerenter', function () {
            setActiveSub(subIdx);
          });
          var anchor = item.querySelector('a');
          if (anchor) {
            anchor.addEventListener('focus', function () {
              setActiveSub(subIdx);
              anchor.setAttribute('tabindex', '0');
            });
            anchor.addEventListener('keydown', function (event) {
              var key = event.key;
              if (key === 'Escape') {
                setActiveTab(null);
                if (lastTrigger) lastTrigger.focus();
                return;
              }
              if (key === 'ArrowDown' || key === 'ArrowUp') {
                event.preventDefault();
                var ul = item.parentNode;
                var anchors = Array.prototype.slice.call(ul.querySelectorAll('a'));
                var pos = anchors.indexOf(anchor);
                var next = key === 'ArrowDown' ? pos + 1 : pos - 1;
                if (next < 0 && lastTrigger) {
                  lastTrigger.focus();
                  return;
                }
                if (next >= 0 && next < anchors.length) {
                  anchors[next].setAttribute('tabindex', '0');
                  anchors[next].focus();
                }
              } else if (key === 'ArrowRight') {
                event.preventDefault();
                // Move to nested column (if visible) or feature link.
                var pane = activeTab !== null ? getRightPane(activeTab) : null;
                if (!pane) return;
                var nestedAnchor = pane.querySelector(
                  '.mega-menu__nested-items.is-visible a'
                );
                if (nestedAnchor) {
                  nestedAnchor.setAttribute('tabindex', '0');
                  nestedAnchor.focus();
                  return;
                }
                var featureAnchor = pane.querySelector('.mega-menu__feature');
                if (featureAnchor) {
                  featureAnchor.setAttribute('tabindex', '0');
                  featureAnchor.focus();
                }
              } else if (key === 'ArrowLeft') {
                event.preventDefault();
                if (lastTrigger) lastTrigger.focus();
              }
            });
          }
        })(subItems[si]);
      }

      // -- Per-nested hover wiring (right column) --------------------
      var nestedLis = container.querySelectorAll('.mega-menu__nested-item');
      for (var ni = 0; ni < nestedLis.length; ni++) {
        (function (li) {
          li.addEventListener('pointerenter', function () {
            // Determine index within the visible nested ul.
            var ul = li.parentNode;
            var liArr = Array.prototype.slice.call(ul.children);
            var idx = liArr.indexOf(li);
            setActiveNested(idx);
          });
          var anchor = li.querySelector('a');
          if (anchor) {
            anchor.addEventListener('keydown', function (event) {
              var key = event.key;
              if (key === 'Escape') {
                setActiveTab(null);
                if (lastTrigger) lastTrigger.focus();
                return;
              }
              if (key === 'ArrowLeft') {
                event.preventDefault();
                // Focus active sub-item anchor in the left column.
                var activeLeftUl = container.querySelector('.mega-menu__left-items.is-active');
                if (!activeLeftUl) return;
                var activeSubItem = activeLeftUl.querySelector('.mega-menu__left-item.is-active a')
                  || activeLeftUl.querySelector('a');
                if (activeSubItem) {
                  activeSubItem.setAttribute('tabindex', '0');
                  activeSubItem.focus();
                }
              } else if (key === 'ArrowDown' || key === 'ArrowUp') {
                event.preventDefault();
                var ul = li.parentNode;
                var anchors = Array.prototype.slice.call(ul.querySelectorAll('a'));
                var pos = anchors.indexOf(anchor);
                var next = key === 'ArrowDown' ? pos + 1 : pos - 1;
                if (next >= 0 && next < anchors.length) {
                  anchors[next].setAttribute('tabindex', '0');
                  anchors[next].focus();
                }
              }
            });
          }
        })(nestedLis[ni]);
      }

      // -- Nav-level focus tracking ----------------------------------
      nav.addEventListener('focusout', function (event) {
        if (!event.relatedTarget || !nav.contains(event.relatedTarget)) {
          // Close on a brief delay so click handlers can still run.
          scheduleClose();
        }
      });

      // -- Document-level Escape & viewport guards -------------------
      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        if (activeTab === null) return;
        var trigger = triggers[activeTab];
        setActiveTab(null);
        if (trigger) trigger.focus();
      });

      // Close menu if the viewport shrinks below the desktop breakpoint.
      var mediaQuery = window.matchMedia('(min-width: 64rem)');
      mediaQuery.addEventListener('change', function (e) {
        if (!e.matches) setActiveTab(null);
      });
    }

    function init(root) {
      if (!root || root.__siteHeaderInitialised) return;
      root.__siteHeaderInitialised = true;

      var stickyEnabled = root.getAttribute('data-sticky-enabled') === 'true';
      var isHome = root.getAttribute('data-is-home') === 'true';
      var transparentOverHero = root.getAttribute('data-transparent-over-hero') === 'true';

      // Publish current rendered header height as a CSS custom property so
      // downstream pages can offset hero / sticky content against it.
      //
      // The transparent-capable header takes `.site-header__inner` out of
      // flow (`position: absolute`), so `root.offsetHeight` collapses to
      // 0 -- the published height value MUST be the inner's rendered
      // height, otherwise downstream sections (hero max-height clamp,
      // wysiwyg-with-toc sticky offset) compute against 0.
      //
      // Separately, also publish `--announcement-bar-height` -- the
      // height of any `.shopify-section--announcement-bar` rendered
      // ahead of the header. The mega-menu panel (issue #23) offsets
      // its content by `56px + var(--announcement-bar-height)` so the
      // panel-inner border-top sits flush with the bottom of the main
      // nav. Falling back to 0 when there's no announcement bar
      // (e.g. localised storefronts that hide it) keeps the formula
      // safe.
      var inner = root.querySelector('.site-header__inner');
      function publishHeight() {
        var src = inner || root;
        var height = src.offsetHeight || 0;
        document.documentElement.style.setProperty(
          '--site-header-height',
          height + 'px'
        );
        var announcement = document.querySelector('.shopify-section--announcement-bar');
        var announcementHeight = announcement ? announcement.offsetHeight : 0;
        document.documentElement.style.setProperty(
          '--announcement-bar-height',
          announcementHeight + 'px'
        );
      }
      // Run once after layout settles, then watch for resize.
      if ('requestAnimationFrame' in window) {
        requestAnimationFrame(publishHeight);
      } else {
        publishHeight();
      }
      window.addEventListener('resize', publishHeight, { passive: true });
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(publishHeight);
        ro.observe(inner || root);
        var announcement2 = document.querySelector('.shopify-section--announcement-bar');
        if (announcement2) ro.observe(announcement2);
      }

      // Initial transparent-over-hero treatment.
      if (isHome && transparentOverHero) {
        root.classList.add('is-at-top');
      } else {
        root.classList.remove('is-at-top');
      }

      // Sticky + hide-on-scroll. Mirrors the headless `useHeaderState` rule:
      // hide only when (scrolled past threshold) AND (scrolling down).
      var lastScrollY = window.scrollY || window.pageYOffset || 0;
      var ticking = false;

      function onScroll() {
        if (!stickyEnabled) return;
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var currentY = window.scrollY || window.pageYOffset || 0;
          var scrolledPast = currentY > SCROLL_THRESHOLD;
          var scrollingDown = currentY > lastScrollY;

          if (scrolledPast) {
            root.classList.add('is-scrolled');
            root.classList.remove('is-at-top');
          } else {
            root.classList.remove('is-scrolled');
            if (isHome && transparentOverHero) {
              root.classList.add('is-at-top');
            }
          }

          // Only hide while scrolled past AND moving down. Restore on up.
          if (scrolledPast && scrollingDown) {
            root.classList.add('is-hidden');
          } else {
            root.classList.remove('is-hidden');
          }

          lastScrollY = currentY < 0 ? 0 : currentY;
          ticking = false;
        });
      }

      if (stickyEnabled) {
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      // ----------------------------------------------------------------
      // Hover state -- only active on transparent-capable (home) and only
      // above the nav-desktop breakpoint (1180px). When hovered, the bar
      // swaps from transparent/white-text back to solid white/charcoal so
      // the menu is legible. Mirrors the headless `setIsHovering` flow
      // with `disableHovering` gated by `useMediaQuery({ down: 'navDesktop' })`.
      // ----------------------------------------------------------------
      if (transparentOverHero) {
        var hoverMql = window.matchMedia('(min-width: 73.75rem)');
        function onMouseEnter() {
          if (hoverMql.matches) root.classList.add('is-hovering');
        }
        function onMouseLeave() {
          root.classList.remove('is-hovering');
        }
        root.addEventListener('mouseenter', onMouseEnter);
        root.addEventListener('mouseleave', onMouseLeave);
        // If the viewport shrinks below the breakpoint while hovering, drop
        // the class so the transparent state can return.
        hoverMql.addEventListener('change', function (e) {
          if (!e.matches) root.classList.remove('is-hovering');
        });
      }

      // ----------------------------------------------------------------
      // Panel-open firewall (QA-07, issue #197).
      //
      // While the transparent-capable home header is at the top of the
      // page, the bar floats transparent with white text + an inverted
      // logo. When the search overlay or any header panel (mobile nav,
      // cart drawer) opens, the bar must revert to the merchant solid
      // palette so it doesn't sit transparent over the panel underneath.
      //
      // `.is-panel-open` is added to the same `:not()` firewall the
      // `.is-hovering` hover-swap already uses, so the existing solid
      // treatment is reused rather than a new colour invented.
      //
      // The open signals are the authoritative document-level markers each
      // panel controller already sets on `<html>`:
      //   - `cart-drawer-open`  (sections/cart-drawer.liquid)
      //   - `mobile-nav-open`   (snippets/mobile-nav-drawer.liquid)
      //   - `nav-open`          (mega-menu, this file)
      // plus the search overlay shell's own `hidden` toggle
      // (snippets/search-overlay.liquid), which has no `<html>` marker.
      // Reading the live state on each mutation keeps the flag correct no
      // matter how many panels overlap, with no refcount to drift.
      // ----------------------------------------------------------------
      var panelOpenClasses = ['cart-drawer-open', 'mobile-nav-open', 'nav-open'];
      var searchOverlay = document.querySelector('[data-search-overlay]');
      function syncPanelOpen() {
        var rootEl = document.documentElement;
        var anyOpen = false;
        for (var p = 0; p < panelOpenClasses.length; p++) {
          if (rootEl.classList.contains(panelOpenClasses[p])) {
            anyOpen = true;
            break;
          }
        }
        if (!anyOpen && searchOverlay && !searchOverlay.hasAttribute('hidden')) {
          anyOpen = true;
        }
        if (anyOpen) {
          root.classList.add('is-panel-open');
        } else {
          root.classList.remove('is-panel-open');
        }
      }
      if ('MutationObserver' in window) {
        var panelObserver = new MutationObserver(syncPanelOpen);
        panelObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ['class']
        });
        if (searchOverlay) {
          panelObserver.observe(searchOverlay, {
            attributes: true,
            attributeFilter: ['hidden']
          });
        }
        syncPanelOpen();
      }

      // ----------------------------------------------------------------
      // Toggle buttons → custom events for downstream sections.
      // ----------------------------------------------------------------
      var hamburger = root.querySelector('[data-mobile-nav-toggle]');
      if (hamburger) {
        hamburger.addEventListener('click', function () {
          document.dispatchEvent(
            new CustomEvent('header:mobile-nav-toggle', {
              bubbles: true,
              detail: { source: 'site-header' }
            })
          );
        });
      }

      var searchBtn = root.querySelector('[data-search-toggle]');
      if (searchBtn) {
        searchBtn.addEventListener('click', function () {
          var expanded = searchBtn.getAttribute('aria-expanded') === 'true';
          searchBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          document.dispatchEvent(
            new CustomEvent('header:search-toggle', {
              bubbles: true,
              detail: { source: 'site-header' }
            })
          );
        });
      }

      var cartBtn = root.querySelector('[data-cart-toggle]');
      if (cartBtn) {
        cartBtn.addEventListener('click', function () {
          document.dispatchEvent(
            new CustomEvent('cart:toggle', {
              bubbles: true,
              detail: { source: 'site-header' }
            })
          );
        });
      }

      // ----------------------------------------------------------------
      // Desktop mega-menu controller (#23).
      // ----------------------------------------------------------------
      initMegaMenu(root);

      // ----------------------------------------------------------------
      // Subscribe to `cart:updated` so AJAX add/remove flows update the
      // badge without a full page reload. Contract:
      //   document.dispatchEvent(new CustomEvent('cart:updated', {
      //     detail: { item_count: <number> }
      //   }))
      // ----------------------------------------------------------------
      document.addEventListener('cart:updated', function (event) {
        var detail = event && event.detail ? event.detail : {};
        // #340: a payload without a count (e.g. a bare line item) used to
        // fall through to 0 and hide the badge while the cart still held
        // items. Only a real count may change the badge.
        if (typeof detail.item_count !== 'number') return;
        var count = detail.item_count;
        var badge = root.querySelector('[data-cart-count]');
        if (!badge) return;
        badge.textContent = String(count);
        if (count > 0) {
          badge.removeAttribute('hidden');
        } else {
          badge.setAttribute('hidden', '');
        }
      });
    }

    function bootstrap() {
      var roots = document.querySelectorAll('[data-site-header]');
      for (var i = 0; i < roots.length; i++) {
        init(roots[i]);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }

    // Re-initialise after a theme-editor section reload.
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      var root = section && section.querySelector
        ? section.querySelector('[data-site-header]')
        : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact-instagram"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* FourSixty embed loader. Injects the third-party script when the
       section has `enable_foursixty_embed` enabled (the slot exists in the
       DOM), then polls for `.fs-has-posts` to reveal the embed once
       hydrated. Mirrors the headless `components/InstagramFeed/index.tsx`
       useEffect block; polling is bounded so a 404'd feed doesn't loop
       forever. */
    var FS_SCRIPT_SRC = '//foursixty.com/media/scripts/fs.embed.v2.5.js';
    var POLL_INTERVAL_MS = 1000;
    var MAX_POLL_TRIES = 5;

    function init(embed) {
      if (embed.__fsInitialised) return;
      embed.__fsInitialised = true;

      if (!document.getElementById('foursixty-script')) {
        var script = document.createElement('script');
        script.id = 'foursixty-script';
        script.async = true;
        script.src = FS_SCRIPT_SRC;
        script.setAttribute('data-feed-id', embed.getAttribute('data-feed-id') || 'runaway-the-label');
        script.setAttribute('data-theme', embed.getAttribute('data-theme') || 'showcase_v2_5');
        script.setAttribute('data-page-size', embed.getAttribute('data-page-size') || '4');
        script.setAttribute('data-open-links-in-same-page', 'false');
        embed.appendChild(script);
      }

      var tries = MAX_POLL_TRIES;
      var timer = setInterval(function () {
        if (embed.querySelector('.fs-has-posts')) {
          embed.removeAttribute('hidden');
          clearInterval(timer);
        }
        tries -= 1;
        if (tries <= 0) clearInterval(timer);
      }, POLL_INTERVAL_MS);
    }

    function bootstrap() {
      var slots = document.querySelectorAll('[data-foursixty-embed]');
      for (var i = 0; i < slots.length; i++) init(slots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
      bootstrap();
    }
    document.addEventListener('shopify:section:load', bootstrap);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /**
   * Hydrates the "You may also like" rail by re-rendering this same section
   * through the Section Rendering API with a related-recommendations request.
   * Falls back to leaving the skeleton in place on network / parse failure.
   */
  (function () {
    const ROOT_SELECTOR = '[data-product-recommendations]';

    /**
     * Algolia Recommend path. Claims its slice from the shared ranked list in
     * `algolia-recommendations.js`, so the sidebar grid (which claims first)
     * and this rail never show the same product. Rejects to the Shopify
     * fallback below on any error or empty result.
     */
    function hydrateFromAlgolia(root) {
      if (root.dataset.algoliaEnabled !== 'true') {
        return Promise.reject(new Error('algolia disabled'));
      }
      const objectId = root.dataset.objectId;
      if (!window.RTLRecsReady || !objectId) {
        return Promise.reject(new Error('algolia unavailable'));
      }

      const limit = parseInt(root.dataset.limit, 10) || 8;
      let recs;
      let claimedHandles = [];

      return window.RTLRecsReady
        .then(function (api) {
          recs = api;
          return recs.handles({
            objectID: objectId,
            model: root.dataset.model,
            gender: root.dataset.pdpGender,
            exclude: root.dataset.excludeHandles,
          });
        })
        .then(function (list) {
          claimedHandles = recs.claim(root.dataset.claimKey, list, limit);
          if (!claimedHandles.length) throw new Error('no algolia handles');
          return recs.cards(claimedHandles);
        })
        .then(function (cards) {
          if (!cards.length) throw new Error('no algolia cards');

          const rail = root.querySelector('.product-recommendations__rail');
          const heading = root.querySelector('.product-recommendations__heading');
          if (!rail) throw new Error('rail missing');

          while (rail.firstChild) rail.removeChild(rail.firstChild);
          cards.forEach(function (card) {
            const item = document.createElement('li');
            item.className = 'product-recommendations__item';
            item.appendChild(card);
            rail.appendChild(item);
          });

          rail.classList.remove('product-recommendations__rail--loading');
          rail.removeAttribute('aria-busy');
          rail.removeAttribute('aria-label');
          if (heading) {
            heading.classList.remove(
              'product-recommendations__heading--placeholder'
            );
            heading.removeAttribute('aria-hidden');
          }
        })
        .catch(function (err) {
          // Hand any claimed-but-unrendered handles back before dropping to
          // the Shopify fallback, so the tab can still use them.
          if (recs && claimedHandles.length) {
            recs.release(root.dataset.claimKey, claimedHandles);
          }
          throw err;
        });
    }

    function hydrateFromShopify(root) {
      const productId = root.dataset.productId;
      const sectionId = root.dataset.sectionId;
      const limit = root.dataset.limit || '8';
      const intent = root.dataset.intent || 'related';
      const fetchUrl = root.dataset.fetchUrl;
      if (!productId || !sectionId || !fetchUrl) return;

      const params = new URLSearchParams({
        section_id: sectionId,
        product_id: productId,
        limit: limit,
        intent: intent,
      });
      const url = `${fetchUrl}?${params.toString()}`;

      return fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const fresh = doc.querySelector(ROOT_SELECTOR);
          if (!fresh) {
            // Endpoint returned no products  -  empty out per headless null contract.
            root.replaceChildren();
            return;
          }
          root.innerHTML = fresh.innerHTML;
        })
        .catch(() => {
          // Leave skeleton  -  Theme Check / a11y prefers a stable DOM here.
        });
    }

    /**
     * Algolia first, Shopify `related` as the fallback  -  mirrors the headless
     * `getAlgoliaProductRecommendations` catch path. The sidebar grid claims
     * its handles before this rail does (script order in product-info.liquid),
     * so the two never overlap.
     */
    function hydrate(root) {
      if (!root || root.dataset.hydrated === 'true') return;
      root.dataset.hydrated = 'true';

      hydrateFromAlgolia(root).catch(() => hydrateFromShopify(root));
    }

    function init() {
      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
        // Skip if this section is itself the rendered response (no product_id
        // would normally still be present on the rehydrated DOM, but
        // recommendations.performed? being true is signalled by the heading
        // node losing its --placeholder modifier in the rendered markup).
        const headingPlaceholder = root.querySelector(
          '.product-recommendations__heading--placeholder'
        );
        if (!headingPlaceholder) return;
        hydrate(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-run on theme editor section refresh.
    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target && event.target.querySelector
        ? event.target.querySelector(ROOT_SELECTOR)
        : null;
      if (root && root.querySelector('.product-recommendations__heading--placeholder')) {
        hydrate(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var STORAGE_KEY = 'rtl.localstorage.recently-viewed';
    var STORAGE_VERSION = 0;
    var MAX_STORED = 12;
    var MAX_VISIBLE = 8;

    function readStore() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return { state: { productIds: {} }, version: STORAGE_VERSION };
        var parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') {
          return { state: { productIds: {} }, version: STORAGE_VERSION };
        }
        if (!parsed.state || typeof parsed.state !== 'object') parsed.state = { productIds: {} };
        if (!parsed.state.productIds || typeof parsed.state.productIds !== 'object') {
          parsed.state.productIds = {};
        }
        if (typeof parsed.version !== 'number') parsed.version = STORAGE_VERSION;
        return parsed;
      } catch (err) {
        console.warn('[recently-viewed] localStorage read failed', err);
        return { state: { productIds: {} }, version: STORAGE_VERSION };
      }
    }

    function writeStore(store) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
      } catch (err) {
        console.warn('[recently-viewed] localStorage write failed', err);
      }
    }

    function addHandle(handle, locale) {
      if (!handle || !locale) return;
      var store = readStore();
      var list = (store.state.productIds[locale] || []).slice();
      var existing = list.indexOf(handle);
      if (existing !== -1) {
        list.splice(existing, 1);
      } else if (list.length >= MAX_STORED) {
        list.pop();
      }
      list.unshift(handle);
      store.state.productIds[locale] = list;
      writeStore(store);
    }

    function readHandles(locale) {
      var store = readStore();
      return (store.state.productIds[locale] || []).slice();
    }

    function fetchRecommendationsHtml(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('recommendations fetch failed: ' + res.status);
        return res.text();
      });
    }

    function fetchCardHtml(handle, cardSectionId) {
      var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(cardSectionId);
      return fetch(url, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('card fetch failed for ' + handle + ': ' + res.status);
        return res.text();
      });
    }

    function extractGridChildren(html, selector) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector(selector);
      if (!node) return [];
      return Array.prototype.slice.call(node.children);
    }

    function extractCard(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector('.product-card');
    }

    function clearGrid(grid) {
      while (grid.firstChild) grid.removeChild(grid.firstChild);
    }

    function hideTab(root, tabName) {
      var tab = root.querySelector('[data-tab="' + tabName + '"]');
      var panel = root.querySelector('[data-panel="' + tabName + '"]');
      if (tab) tab.hidden = true;
      if (panel) panel.hidden = true;
    }

    function showTab(root, tabName) {
      var tab = root.querySelector('[data-tab="' + tabName + '"]');
      if (tab) tab.hidden = false;
    }

    function activateTab(root, tabName) {
      var tabs = root.querySelectorAll('[role="tab"]');
      Array.prototype.forEach.call(tabs, function (tab) {
        var isMatch = tab.dataset.tab === tabName;
        tab.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        tab.setAttribute('tabindex', isMatch ? '0' : '-1');
        if (isMatch) {
          tab.classList.add('rv-tab--active');
        } else {
          tab.classList.remove('rv-tab--active');
        }
      });
      var panels = root.querySelectorAll('[role="tabpanel"]');
      Array.prototype.forEach.call(panels, function (panel) {
        if (panel.dataset.panel === tabName) {
          panel.hidden = false;
          panel.classList.add('rv-carousel-outer--active');
        } else {
          panel.hidden = true;
          panel.classList.remove('rv-carousel-outer--active');
        }
      });
    }

    function bindTabSwitching(root) {
      var tabs = root.querySelectorAll('[role="tab"]');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          activateTab(root, tab.dataset.tab);
        });
        tab.addEventListener('keydown', function (event) {
          var visibleTabs = Array.prototype.filter.call(tabs, function (t) {
            return !t.hidden;
          });
          var idx = visibleTabs.indexOf(tab);
          if (idx === -1) return;
          var nextIdx = idx;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            nextIdx = (idx + 1) % visibleTabs.length;
          } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            nextIdx = (idx - 1 + visibleTabs.length) % visibleTabs.length;
          } else if (event.key === 'Home') {
            nextIdx = 0;
          } else if (event.key === 'End') {
            nextIdx = visibleTabs.length - 1;
          } else {
            return;
          }
          event.preventDefault();
          var next = visibleTabs[nextIdx];
          activateTab(root, next.dataset.tab);
          next.focus();
        });
      });
    }

    function hideSection(root) {
      root.hidden = true;
    }

    function init(root) {
      var locale = root.dataset.locale;
      var currentHandle = root.dataset.currentProductHandle;
      var recommendationsUrl = root.dataset.recommendationsUrl;
      var cardSectionId = root.dataset.cardSectionId;
      var recommendationsTrack = root.querySelector('[data-recommendations-grid]');
      var recentlyViewedTrack = root.querySelector('[data-recently-viewed-grid]');
      // Target the inner flex wrapper for card injection so the rv-carousel-inner stays intact
      var recommendationsGrid = recommendationsTrack ? (recommendationsTrack.querySelector('.rv-carousel-inner') || recommendationsTrack) : null;
      var recentlyViewedGrid = recentlyViewedTrack ? (recentlyViewedTrack.querySelector('.rv-carousel-inner') || recentlyViewedTrack) : null;

      /*
        Arrow buttons -- scroll the currently-active track by one card
        width and reflect prev/next disabled state based on scroll
        position. Hidden entirely (display: none via [hidden]) when the
        active track isn't actually overflowing -- e.g. when there are
        only 4 cards on desktop (each at 25% width, total 100% = no
        scroll possible).
      */
      var arrowsWrapper = root.querySelector('[data-rv-arrows]');
      var prevArrow = root.querySelector('[data-rv-arrow="prev"]');
      var nextArrow = root.querySelector('[data-rv-arrow="next"]');

      function activeTrack() {
        var activePanel = root.querySelector('.rv-carousel-outer--active');
        return activePanel ? activePanel.querySelector('.rv-carousel-track') : null;
      }

      function refreshArrows() {
        if (!arrowsWrapper || !prevArrow || !nextArrow) return;
        var track = activeTrack();
        if (!track) {
          arrowsWrapper.hidden = true;
          return;
        }
        // 2px slack handles sub-pixel rounding so the arrows don't
        // think there's still scroll left when the track is at the end.
        var canScroll = track.scrollWidth - track.clientWidth > 2;
        if (!canScroll) {
          arrowsWrapper.hidden = true;
          return;
        }
        arrowsWrapper.hidden = false;
        prevArrow.disabled = track.scrollLeft <= 2;
        nextArrow.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-rv-arrow]'), function (btn) {
        btn.addEventListener('click', function () {
          var track = activeTrack();
          if (!track) return;
          var firstCard = track.querySelector('.product-card, .recently-viewed-card');
          var step = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth / 4;
          var dir = btn.getAttribute('data-rv-arrow') === 'next' ? 1 : -1;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });

      // Re-evaluate on scroll (debounced via rAF), tab switch, and
      // window resize so the arrows track real scroll capability.
      Array.prototype.forEach.call(root.querySelectorAll('.rv-carousel-track'), function (trackEl) {
        var ticking = false;
        trackEl.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            refreshArrows();
            ticking = false;
          });
        }, { passive: true });
      });
      window.addEventListener('resize', refreshArrows);
      Array.prototype.forEach.call(root.querySelectorAll('[data-tab]'), function (tab) {
        tab.addEventListener('click', function () {
          // The tab handler updates --active in the same task; defer so
          // activeTrack() reads the post-switch panel.
          requestAnimationFrame(refreshArrows);
        });
      });
      // Initial state -- arrows stay hidden until cards land. Called
      // again from maybeFinish() once the SRA fetch settles.
      refreshArrows();

      // Persist current handle BEFORE rendering, so that on a clean profile
      // the customer sees their own history populate as they browse.
      addHandle(currentHandle, locale);

      var hasRecommendations = false;
      var hasRecentlyViewed = false;
      var pending = 2;

      function maybeFinish() {
        pending -= 1;
        if (pending > 0) return;
        if (!hasRecommendations) hideTab(root, 'customers-viewed');
        if (!hasRecentlyViewed) hideTab(root, 'recently-viewed');
        if (!hasRecommendations && !hasRecentlyViewed) {
          hideSection(root);
          return;
        }
        var defaultTab = hasRecommendations ? 'customers-viewed' : 'recently-viewed';
        if (hasRecommendations) showTab(root, 'customers-viewed');
        if (hasRecentlyViewed) showTab(root, 'recently-viewed');
        activateTab(root, defaultTab);
        root.hidden = false;
        // Cards have landed -- re-evaluate scroll capability so the
        // arrow visibility/disabled state reflects the post-fetch
        // track width.
        requestAnimationFrame(refreshArrows);
      }

      /**
       * Algolia Recommend path for the "Customers also viewed" tab. Claims
       * from the shared ranked list, continuing after the sidebar grid (3)
       * and the full-width rail, so no product repeats across the PDP.
       *
       * Replaces the old `offset: 3` positional dedup, which was applied to
       * the RAW Shopify result while the sidebar filtered by gender first --
       * the two overlapped whenever a top-3 related product was the opposite
       * gender.
       */
      function customersAlsoViewedFromAlgolia() {
        if (root.dataset.algoliaEnabled !== 'true') {
          return Promise.reject(new Error('algolia disabled'));
        }
        var objectId = root.dataset.objectId;
        if (!window.RTLRecsReady || !objectId) {
          return Promise.reject(new Error('algolia unavailable'));
        }

        var recs;
        var claimedHandles = [];
        return window.RTLRecsReady
          .then(function (api) {
            recs = api;
            return recs.handles({
              objectID: objectId,
              model: root.dataset.model,
              gender: root.dataset.pdpGender,
              exclude: root.dataset.excludeHandles
            });
          })
          .then(function (list) {
            claimedHandles = recs.claim(root.dataset.claimKey, list, MAX_VISIBLE);
            if (!claimedHandles.length) throw new Error('no algolia handles');
            return recs.cards(claimedHandles, cardSectionId);
          })
          .then(function (cards) {
            if (!cards.length) throw new Error('no algolia cards');
            clearGrid(recommendationsGrid);
            cards.forEach(function (node) {
              recommendationsGrid.appendChild(node);
            });
            hasRecommendations = true;
          })
          .catch(function (err) {
            // Hand any claimed-but-unrendered handles back before dropping to
            // the Shopify fallback below.
            if (recs && claimedHandles.length) {
              recs.release(root.dataset.claimKey, claimedHandles);
            }
            throw err;
          });
      }

      // Customers-also-viewed: Algolia first, Shopify section HTML as fallback.
      customersAlsoViewedFromAlgolia()
        .catch(function () {
          return fetchRecommendationsHtml(recommendationsUrl).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var trackEl = doc.querySelector('[data-recommendations-grid]');
            var innerEl = trackEl ? trackEl.querySelector('.rv-carousel-inner') : null;
            var sourceEl = innerEl || trackEl;
            var children = sourceEl ? Array.prototype.slice.call(sourceEl.children) : [];
            var realCards = children.filter(function (node) {
              return node.nodeType === 1 && !node.classList.contains('recently-viewed-card--skeleton');
            });
            if (realCards.length > 0) {
              clearGrid(recommendationsGrid);
              realCards.slice(0, MAX_VISIBLE).forEach(function (node) {
                recommendationsGrid.appendChild(node);
              });
              hasRecommendations = true;
            }
          });
        })
        .catch(function (err) {
          console.warn('[recently-viewed] customers-also-viewed fetch failed', err);
        })
        .then(maybeFinish);

      // Recently-viewed: client-side render from localStorage handles.
      var handles = readHandles(locale).filter(function (h) {
        return h && h !== currentHandle;
      }).slice(0, MAX_VISIBLE);

      if (handles.length === 0) {
        clearGrid(recentlyViewedGrid);
        maybeFinish();
      } else {
        Promise.all(handles.map(function (handle) {
          return fetchCardHtml(handle, cardSectionId)
            .then(function (html) {
              return { handle: handle, node: extractCard(html) };
            })
            .catch(function (err) {
              console.warn('[recently-viewed] card fetch failed', err);
              return { handle: handle, node: null };
            });
        }))
          .then(function (results) {
            clearGrid(recentlyViewedGrid);
            results.forEach(function (result) {
              if (result.node) {
                recentlyViewedGrid.appendChild(result.node);
                hasRecentlyViewed = true;
              }
            });
          })
          .catch(function (err) {
            console.warn('[recently-viewed] recently-viewed batch failed', err);
          })
          .then(maybeFinish);
      }

      bindTabSwitching(root);
    }

    function boot() {
      var roots = document.querySelectorAll('[data-section-type="recently-viewed"]');
      Array.prototype.forEach.call(roots, init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    'use strict';

    // #243/#244 (QA Slide 4): customer-meaningful facets only. Dropped
    // `collections` (client asked to remove the Collection filter), plus
    // `option_names` (option NAMES, redundant with options.size), `vendor`
    // (single brand), and `tags` (raw internal tags). Colour facet + size-order
    // sorting are tracked as follow-ups (need the Algolia colour attribute +
    // a size comparator). Keep in sync with snippets/search-filters.liquid.
    var FACETS = [
      'options.size',
      'price_range',
      'product_type',
    ];

    // #244 / QA Slide 4: garment-size order for the Size facet. Algolia's
    // refinementList `sortBy` only supports isRefined/count/name, so size order
    // (XXS→XXL) is applied via `transformItems`. Alpha sizes rank by this list;
    // numeric sizes (6/8/10…) sort ascending after them; one-size/unknown last.
    var SIZE_ORDER = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XXXXL'];
    function sizeRank(value) {
      var s = String(value == null ? '' : value).trim().toUpperCase();
      var i = SIZE_ORDER.indexOf(s);
      if (i !== -1) return i;
      if (/^\d+(\.\d+)?$/.test(s)) return 100 + parseFloat(s);
      return 900;
    }

    function SearchController(root) {
      this.root = root;
      this.algolia = window.RTLAlgolia || null;
      this.instantsearch =
        typeof window.instantsearch === 'function'
          ? window.instantsearch
          : null;
      this.searchInstance = null;
      this.collectionsInstance = null;
      this.activeTab = 'products';
      this.productCounts = { products: 0, collections: 0 };
      this.lastResults = { products: null, collections: null };

      if (!this.algolia || !this.instantsearch) {
        // The dependencies failed to load. The init() path now gates on
        // `RTLAlgolia.ready()` so this branch should be unreachable in
        // production  -  log a single warning so a regression in the load
        // order is visible in the console instead of silently degrading
        // to the no-JS shell.
        if (typeof console !== 'undefined' && console.warn) {
          console.warn(
            '[rtl-search] SearchController instantiated before ' +
              'RTLAlgolia/instantsearch were ready  -  falling back to no-JS ' +
              'shell. This indicates a load-order regression.'
          );
        }
        return;
      }

      this.cacheElements();
      this.initLabels();
      this.normaliseUrl();
      this.bindTabs();
      this.bindFilterTrigger();
      this.bindFilterDropdowns();
      this.bindSort();
      this.bindLoadMore();
      this.bindInsightsClicks();
      this.bindForm();
      this.mount();

      // Theme-editor idempotency.
      var self = this;
      document.addEventListener('shopify:section:unload', function (event) {
        if (root.contains(event.target)) self.dispose();
      });
    }

    SearchController.prototype.cacheElements = function () {
      var root = this.root;
      this.elements = {
        heading: root.querySelector('[data-search-heading]'),
        input: root.querySelector('[data-search-input]'),
        form: root.querySelector('[data-search-form]'),
        stats: root.querySelector('[data-search-stats]'),
        count: root.querySelector('[data-product-count]'),
        liveRegion: root.querySelector('[data-search-live-region]'),
        tabs: root.querySelectorAll('[data-search-tab]'),
        panels: {
          products: root.querySelector('[data-search-panel="products"]'),
          collections: root.querySelector(
            '[data-search-panel="collections"]'
          ),
        },
        tabCounts: {
          products: root.querySelector('[data-search-tab-count="products"]'),
          collections: root.querySelector(
            '[data-search-tab-count="collections"]'
          ),
        },
        productsHits: root.querySelector('[data-search-products-hits]'),
        collectionsHits: root.querySelector('[data-search-collections-hits]'),
        loadMore: root.querySelector('[data-search-load-more="products"]'),
        loadMoreLabel: root.querySelector('[data-search-load-more-label="products"]'),
        loadMoreCollections: root.querySelector('[data-search-load-more="collections"]'),
        loadMoreCollectionsLabel: root.querySelector('[data-search-load-more-label="collections"]'),
        filterTrigger: root.querySelector('[data-search-filter-trigger]'),
        filterBar: root.querySelector('[data-search-filter-bar]'),
        viewedCount: {
          products: root.querySelector('[data-search-viewed-count="products"]'),
          collections: root.querySelector('[data-search-viewed-count="collections"]'),
        },
        progress: {
          products: root.querySelector('[data-search-progress="products"]'),
          collections: root.querySelector('[data-search-progress="collections"]'),
        },
        emptyState: root.querySelector('[data-search-empty-state]'),
        emptyHeading: root.querySelector('[data-search-empty-heading]'),
        currentRefinements: root.querySelector(
          '[data-search-current-refinements]'
        ),
        currentRefinementsContainer: root.querySelector(
          '[data-search-current-refinements-container]'
        ),
        clearRefinementsBtn: root.querySelector(
          '[data-search-clear-refinements]'
        ),
        sortBy: root.querySelector('[data-search-sort-by]'),
        sortBtn: root.querySelector('[data-search-sort-btn]'),
        sortPanel: root.querySelector('[data-search-sort-panel]'),
        sortActiveLabel: root.querySelector('[data-search-sort-active-label]'),
        sortLinks: root.querySelectorAll('[data-search-sort-link]'),
        productTemplate: document.getElementById(
          'rtl-algolia-product-card'
        ),
        collectionTemplate: document.getElementById(
          'rtl-algolia-collection-card'
        ),
        filterGroups: root.querySelectorAll('[data-search-filter]'),
      };
    };

    /**
     * Parse the server-rendered facet-label data and stash the inline SVG +
     * translated "Show more/less" copy the refinement templates need. Inline
     * SVG is required because InstantSearch templates are plain strings; the
     * Liquid icon snippet cannot run inside a javascript block. The markup
     * matches `assets/icon-close.svg` so the PLP checkbox box renders the same
     * tick/close glyph.
     */
    // Decode HTML entities in strings destined for textContent. Shopify's `| t`
    // filter HTML-escapes interpolated translations (e.g. the apostrophe in
    // "You've" becomes &#39;); rendered via textContent those entities show
    // literally ("YOU&#39;VE VIEWED …"). Entity-source-agnostic, no innerHTML.
    function decodeEntities(str) {
      if (typeof str !== 'string' || str.indexOf('&') === -1) return str;
      var el = document.createElement('textarea');
      el.innerHTML = str;
      return el.value;
    }

    SearchController.prototype.initLabels = function () {
      var data = {};
      var node = this.root.querySelector('[data-search-filter-labels]');
      if (node) {
        try {
          data = JSON.parse(node.textContent) || {};
        } catch (err) {
          data = {};
        }
      }
      this.labelData = data;
      this.collectionTitles = data.collections || {};
      this.translations = {
        show_more: decodeEntities(data.show_more) || 'Show more',
        show_less: decodeEntities(data.show_less) || 'Show less',
        viewed_products:
          decodeEntities(data.viewed_products) ||
          "You've viewed __SHOWN__ of __TOTAL__ products",
        viewed_collections:
          decodeEntities(data.viewed_collections) ||
          "You've viewed __SHOWN__ of __TOTAL__ collections",
        view_more: decodeEntities(data.view_more) || 'View More',
        result_count_one: decodeEntities(data.result_count_one) || '__COUNT__ result',
        result_count_other:
          decodeEntities(data.result_count_other) || '__COUNT__ results',
      };
      this.icons = {
        close:
          '<svg viewBox="0 0 24 24" width="10" height="10" fill="none" ' +
          'aria-hidden="true"><g stroke="currentColor" ' +
          'stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M18 6 6 18M6 6l12 12"/></g></svg>',
      };
    };

    /**
     * Convert a raw Algolia facet value into a human-readable label that
     * mirrors the PLP filter copy:
     *   - collections : handle -> collection title (from the server map),
     *                   falling back to a Title Case of the handle.
     *   - options.size: keep the size token as-is (L / M / S) but upper-cased.
     *   - price_range : a bucket value like "100:150" or "100" -> "$100 - $150"
     *                   / "$100+"; anything already formatted passes through.
     *   - everything else: replace handle separators and Title Case so values
     *                   like "maxi-dresses" read "Maxi Dresses".
     */
    SearchController.prototype.facetItemLabel = function (facet, rawLabel) {
      var value = rawLabel === null || rawLabel === undefined ? '' : String(rawLabel);
      if (!value) return value;

      if (facet === 'collections') {
        if (this.collectionTitles[value]) return this.collectionTitles[value];
        return this.titleCase(value);
      }

      if (facet === 'options.size') {
        // Sizes are short tokens (xs/s/m/l/xl or numeric) - upper-case the
        // alpha sizes, leave numeric/onesize labels untouched.
        if (/^[a-z]{1,3}$/i.test(value)) return value.toUpperCase();
        return value;
      }

      if (facet === 'price_range') {
        return this.formatPriceBucket(value);
      }

      return this.titleCase(value);
    };

    /**
     * Title Case a handle-ish string: split on `-`/`_`/spaces, capitalise each
     * word. Used for collection / type / tag / brand facet values.
     */
    SearchController.prototype.titleCase = function (value) {
      return String(value)
        .split(/[-_\s]+/)
        .map(function (word) {
          if (!word) return word;
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
    };

    /**
     * Format an Algolia `price_range` bucket value into a readable range. The
     * index emits buckets as either "min:max" (e.g. "100:150") or a single
     * lower bound for the open-ended top bucket. Falls back to the raw value
     * when the shape is unexpected.
     */
    SearchController.prototype.formatPriceBucket = function (value) {
      var money = this.algolia.formatPrice;
      var parts = String(value).split(/[:\-]/);
      if (parts.length === 2 && parts[0] !== '' && parts[1] !== '') {
        return money(parts[0]) + ' - ' + money(parts[1]);
      }
      if (parts.length === 1 && parts[0] !== '') {
        return money(parts[0]) + '+';
      }
      return value;
    };

    /**
     * Read both `?q=` and `?query=` so legacy bookmarks keep working, then
     * collapse them down to a single canonical `?q=` URL via replaceState.
     * Also seeds the visible input value when `search.terms` was empty
     * server-side (i.e. `?query=` was used).
     */
    SearchController.prototype.normaliseUrl = function () {
      var parsed = this.algolia.normaliseSearchParams();
      this.initialQuery = parsed.query;
      this.activeTab = parsed.tab === 'collections' ? 'collections' : 'products';

      if (this.elements.input && !this.elements.input.value && parsed.query) {
        this.elements.input.value = parsed.query;
      }
      if (this.elements.heading && parsed.query) {
        var label = window.theme &&
          window.theme.translations &&
          window.theme.translations.search_title;
        // Fall back to inserting the query into the existing heading when no
        // pre-rendered translation is available. The server-side render
        // already handles the `search.terms != blank` case; this block only
        // hydrates when `?query=` (legacy URL) was used and the server saw
        // an empty `search.terms`.
        var headingText = this.elements.heading.textContent.trim();
        var alreadyHasQuery = headingText.length > 0 &&
          headingText.toLowerCase().indexOf(parsed.query.toLowerCase()) !== -1;
        if (!alreadyHasQuery && (headingText === '' || !parsed.raw.get('q'))) {
          this.elements.heading.textContent = (label || 'Showing results for')
            + ' ' + parsed.query;
        }
      }

      // Canonicalise URL  -  promote `?query=` → `?q=` without reload.
      if (parsed.query) {
        this.algolia.replaceQueryParam('q', parsed.query);
      }
      if (this.activeTab !== 'products') {
        this.algolia.replaceQueryParam('tab', this.activeTab);
      }
    };

    SearchController.prototype.bindForm = function () {
      var self = this;
      if (!this.elements.form) return;
      this.elements.form.addEventListener('submit', function (event) {
        // Allow native submit (full-page navigation)  -  the new page will
        // re-mount the controller with the new query.
        var value = self.elements.input ? self.elements.input.value : '';
        if (!value) {
          event.preventDefault();
        }
      });

      // Live-update results as the user types (debounced) so the in-place
      // experience matches the "second query" screenshot.
      var timer = null;
      if (this.elements.input) {
        this.elements.input.addEventListener('input', function () {
          if (timer) window.clearTimeout(timer);
          timer = window.setTimeout(function () {
            var newQuery = self.elements.input.value;
            if (self.searchInstance && self.searchInstance.helper) {
              self.searchInstance.helper.setQuery(newQuery).search();
            }
            if (self.collectionsInstance && self.collectionsInstance.helper) {
              self.collectionsInstance.helper.setQuery(newQuery).search();
            }
            self.algolia.replaceQueryParam('q', newQuery);
          }, 250);
        });
      }
    };

    SearchController.prototype.bindTabs = function () {
      var self = this;
      var tabs = this.elements.tabs;
      if (!tabs || !tabs.length) return;

      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          self.activateTab(tab.getAttribute('data-search-tab'));
        });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          var next = tab.nextElementSibling || tabs[0];
          var prev =
            tab.previousElementSibling || tabs[tabs.length - 1];
          var target = event.key === 'ArrowRight' ? next : prev;
          if (target && target.getAttribute('data-search-tab')) {
            target.focus();
            self.activateTab(target.getAttribute('data-search-tab'));
          }
        });
      });

      // Apply initial active tab from URL.
      if (this.activeTab !== 'products') {
        this.activateTab(this.activeTab);
      }
    };

    SearchController.prototype.activateTab = function (name) {
      if (name !== 'products' && name !== 'collections') return;
      this.activeTab = name;
      var tabs = this.elements.tabs;
      Array.prototype.forEach.call(tabs, function (tab) {
        var isActive = tab.getAttribute('data-search-tab') === name;
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
        tab.classList.toggle('search-tabs__tab--active', isActive);
      });
      var panels = this.elements.panels;
      if (panels.products) {
        if (name === 'products') {
          panels.products.removeAttribute('hidden');
          panels.products.classList.add('search-results__panel--active');
        } else {
          panels.products.setAttribute('hidden', '');
          panels.products.classList.remove('search-results__panel--active');
        }
      }
      if (panels.collections) {
        if (name === 'collections') {
          panels.collections.removeAttribute('hidden');
          panels.collections.classList.add('search-results__panel--active');
        } else {
          panels.collections.setAttribute('hidden', '');
          panels.collections.classList.remove(
            'search-results__panel--active'
          );
        }
      }
      this.algolia.replaceQueryParam(
        'tab',
        name === 'products' ? null : name
      );
      this.refreshEmptyState();
    };

    /**
     * Filter & Sort trigger (#214 task 2). Mirrors the collection-page
     * `[data-filter-trigger]` behaviour: the filter bar is hidden by default
     * and the trigger toggles its visibility + the button's `aria-expanded`
     * (which also flips the plus/minus icon via CSS).
     */
    SearchController.prototype.bindFilterTrigger = function () {
      var trigger = this.elements.filterTrigger;
      var bar = this.elements.filterBar;
      if (!trigger || !bar) return;
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          bar.setAttribute('hidden', '');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          bar.removeAttribute('hidden');
        }
      });
    };

    /**
     * Render the "You've viewed X of Y" count line + progress bar for a panel
     * (#214 task 4), mirroring the headless `SearchResultsView` load-more
     * container. `shown` is the rendered hit count, `total` is `nbHits`. The
     * region hides when there is nothing to show (no query / zero hits).
     */
    SearchController.prototype.renderLoadMoreMeta = function (context, shown, total) {
      var countEl = this.elements.viewedCount[context];
      var progressEl = this.elements.progress[context];
      var hasResults = total > 0 && shown > 0;

      if (countEl) {
        if (hasResults) {
          var template =
            context === 'collections'
              ? this.translations.viewed_collections
              : this.translations.viewed_products;
          countEl.textContent = template
            .replace('__SHOWN__', String(shown))
            .replace('__TOTAL__', String(total));
          countEl.removeAttribute('hidden');
        } else {
          countEl.textContent = '';
          countEl.setAttribute('hidden', '');
        }
      }

      if (progressEl) {
        if (hasResults) {
          var ratio = total > 0 ? Math.min(shown / total, 1) : 0;
          progressEl.style.setProperty('--search-progress', String(ratio));
          progressEl.removeAttribute('hidden');
        } else {
          progressEl.setAttribute('hidden', '');
        }
      }
    };

    /**
     * Open/close behaviour for the PLP-styled filter dropdowns (mirrors the
     * minimal interaction in filter-bar.js): toggle the panel + aria-expanded
     * on the trigger button, close on outside click and Escape. Only one
     * dropdown stays open at a time, matching the collection page.
     */
    SearchController.prototype.bindFilterDropdowns = function () {
      var self = this;
      var dropdowns = this.root.querySelectorAll('[data-search-filter-dropdown]');
      if (!dropdowns || !dropdowns.length) return;

      function close(dropdown) {
        var btn = dropdown.querySelector('[data-search-filter-btn]');
        var panel = dropdown.querySelector('[data-search-filter-panel]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('hidden', '');
      }

      function closeAll(except) {
        Array.prototype.forEach.call(dropdowns, function (dropdown) {
          if (dropdown !== except) close(dropdown);
        });
      }

      Array.prototype.forEach.call(dropdowns, function (dropdown) {
        var btn = dropdown.querySelector('[data-search-filter-btn]');
        var panel = dropdown.querySelector('[data-search-filter-panel]');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAll(dropdown);
          if (isOpen) {
            close(dropdown);
          } else {
            btn.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('hidden');
          }
        });

        // #244 / QA Slide 15: on mobile, auto-close the panel once a filter is
        // selected (the client flagged it "doesn't automatically hide").
        // Desktop keeps the panel open so multiple refinements can be picked in
        // one go. Bound on `click` (not `change`): InstantSearch refines and
        // re-renders the option list synchronously, detaching the native input
        // before a `change` event can bubble to the panel. The close is deferred
        // to the next tick so it runs AFTER the widget's re-render.
        // CAPTURE phase (3rd arg `true`): InstantSearch's refine handler stops
        // the click propagating, so a bubble-phase listener on the panel never
        // fires. Capture runs top-down before that handler. The row is
        // `.search-filters__option` (no `.filter-checkbox` wrapper under a custom
        // item template). Close is deferred so it lands after the refine re-render.
        panel.addEventListener(
          'click',
          function (event) {
            if (
              event.target &&
              event.target.closest('.search-filters__option') &&
              window.matchMedia('(max-width: 768px)').matches
            ) {
              window.setTimeout(function () {
                close(dropdown);
              }, 0);
            }
          },
          true
        );
      });

      document.addEventListener('click', function (event) {
        if (!self.root.contains(event.target)) {
          closeAll(null);
          return;
        }
        if (!event.target.closest('[data-search-filter-dropdown]')) {
          closeAll(null);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeAll(null);
      });
    };

    /**
     * Styled sort dropdown wiring. The PLP-styled list links carry a replica
     * suffix in `data-search-sort-value`; clicking one switches the products
     * InstantSearch index via the helper. Replaces the previous native
     * `<select>` + `sortBy` widget combo (which rendered a second, unstyled
     * select on the page).
     */
    SearchController.prototype.bindSort = function () {
      var self = this;
      var els = this.elements;
      if (!els.sortLinks || !els.sortLinks.length) return;

      var cfg = this.algolia.getConfig();

      function indexForValue(value) {
        var replicas = cfg.replicas || {};
        return replicas[value] || cfg.productsIndex;
      }

      // Toggle the sort panel open/closed.
      if (els.sortBtn && els.sortPanel) {
        els.sortBtn.addEventListener('click', function () {
          var isOpen = els.sortBtn.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            els.sortBtn.setAttribute('aria-expanded', 'false');
            els.sortPanel.setAttribute('hidden', '');
          } else {
            els.sortBtn.setAttribute('aria-expanded', 'true');
            els.sortPanel.removeAttribute('hidden');
          }
        });
        document.addEventListener('click', function (event) {
          if (els.sortBy && !els.sortBy.contains(event.target)) {
            els.sortBtn.setAttribute('aria-expanded', 'false');
            els.sortPanel.setAttribute('hidden', '');
          }
        });
      }

      Array.prototype.forEach.call(els.sortLinks, function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          var value = link.getAttribute('data-search-sort-value');
          var label = link.getAttribute('data-search-sort-label') || '';
          var instance = self.searchInstance;
          var helper = instance && instance.helper;
          if (!helper) return;

          helper.setIndex(indexForValue(value)).search();

          Array.prototype.forEach.call(els.sortLinks, function (other) {
            var isActive = other === link;
            other.classList.toggle('sort-dropdown__link--active', isActive);
            var li = other.closest('[role="option"]');
            if (li) li.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          if (els.sortActiveLabel) {
            els.sortActiveLabel.textContent =
              self.sortLabelPrefix() + ': ' + label;
          }
          if (els.sortBtn && els.sortPanel) {
            els.sortBtn.setAttribute('aria-expanded', 'false');
            els.sortPanel.setAttribute('hidden', '');
          }
          self.announce('Sort updated: ' + label);
        });
      });
    };

    /**
     * Resolve the localised "Sort by" prefix once. The active-label span is
     * server-rendered with the prefix already in place; this reads it back so
     * the click handler can rebuild the label without a hardcoded English
     * string.
     */
    SearchController.prototype.sortLabelPrefix = function () {
      if (this._sortPrefix) return this._sortPrefix;
      var label = this.elements.sortActiveLabel;
      var text = label ? label.textContent : '';
      var idx = text.indexOf(':');
      this._sortPrefix = idx > -1 ? text.slice(0, idx).trim() : 'Sort by';
      return this._sortPrefix;
    };

    SearchController.prototype.bindLoadMore = function () {
      // Wired via the customWidget added during mount().
    };

    /**
     * Send an Algolia click event when a product result is opened (#341).
     * Delegated, because InstantSearch re-renders the hit list on every
     * search. Cards only carry `data-insights-query-id` when the search was
     * tracked, so untracked searches send nothing.
     */
    SearchController.prototype.bindInsightsClicks = function () {
      var hits = this.elements.productsHits;
      if (!hits) return;
      hits.addEventListener('click', function (event) {
        var insights = window.RTLAlgoliaInsights;
        if (!insights || !event.target.closest('a[href]')) return;
        var card = event.target.closest('[data-insights-query-id]');
        if (!card) return;
        insights.clickedAfterSearch({
          index: card.getAttribute('data-insights-index'),
          queryID: card.getAttribute('data-insights-query-id'),
          objectID: card.getAttribute('data-insights-object-id'),
          productId: card.getAttribute('data-insights-product-id'),
          position: card.getAttribute('data-insights-position'),
        });
      });
    };

    SearchController.prototype.mount = function () {
      var cfg = this.algolia.getConfig();
      var client = this.algolia.createSearchClient();
      if (!client) return;

      // `insights: false` (#341): Insights events are owned by
      // `RTLAlgoliaInsights` (clicks bound in `bindInsightsClicks`). Left
      // unset, InstantSearch adds its own Insights middleware as soon as
      // Algolia's automatic-events setting is switched on, which would send
      // a second set of events through the app embed's `window.aa`.
      this.searchInstance = this.instantsearch({
        indexName: cfg.productsIndex,
        searchClient: client,
        insights: false,
        future: { preserveSharedStateOnUnmount: true },
        routing: this.buildRouting(cfg),
      });

      this.collectionsInstance = this.instantsearch({
        indexName: cfg.collectionsIndex,
        searchClient: client,
        insights: false,
        future: { preserveSharedStateOnUnmount: true },
      });

      this.addProductWidgets(cfg);
      this.addCollectionWidgets(cfg);

      var initialQuery = this.initialQuery || '';
      if (initialQuery) {
        // Both instances start with the same query.
        this.searchInstance.addWidgets([
          this.instantsearch.widgets.configure({
            query: initialQuery,
            hitsPerPage: cfg.hitsPerPage,
            facets: ['*'],
          }),
        ]);
        this.collectionsInstance.addWidgets([
          this.instantsearch.widgets.configure({
            query: initialQuery,
            // Lift the old 12-item cap (#214 task 3): page through all
            // matching collections at the products page size; View More
            // advances beyond the first page.
            hitsPerPage: cfg.hitsPerPage,
          }),
        ]);
      } else {
        this.searchInstance.addWidgets([
          this.instantsearch.widgets.configure({
            hitsPerPage: cfg.hitsPerPage,
            facets: ['*'],
          }),
        ]);
      }

      try {
        this.searchInstance.start();
      } catch (err) {
        // Some legacy ES2017 environments throw on `start()` if widgets
        // weren't added  -  swallow and rely on the no-JS fallback.
      }
      try {
        this.collectionsInstance.start();
      } catch (err) {
        /* see above */
      }
    };

    SearchController.prototype.buildRouting = function () {
      var widgets = this.instantsearch.widgets;
      var stateMappings = this.instantsearch.stateMappings;
      // InstantSearch v4 UMD exposes the history router under
      // `instantsearch.routers.history`. The earlier `.history` shorthand
      // was undefined on this build and caused `buildRouting()` to bail
      // out silently  -  URL canonicalisation worked only because
      // `bindForm` + `activateTab` + `normaliseUrl` call
      // `replaceQueryParam()` directly. Fall back to the legacy path for
      // older bundles.
      var historyRouter =
        (this.instantsearch.routers && this.instantsearch.routers.history) ||
        this.instantsearch.history;
      if (!historyRouter || !stateMappings) return undefined;

      // URL param keys that the router MUST leave alone  -  they're owned by
      // other channels and any of them appearing in `routeState` would
      // misroute as a fake refinement otherwise.
      //   q, query               -  canonical search query (q wins; query is
      //                            kept on parse for legacy bookmarks)
      //   tab                    -  Products/Collections tab (managed by
      //                            activateTab via replaceQueryParam)
      //   _fd, _sc               -  Shopify primary-domain bypass params
      //                            (preserved so preview links keep working)
      //   preview_theme_id       -  Shopify theme preview id (same reason)
      //   page                   -  intentionally NOT persisted; matches
      //                            headless `useAlgoliaData` behaviour
      //                            (reload = page 0, View More re-advances)
      var RESERVED = {
        q: true,
        query: true,
        tab: true,
        _fd: true,
        _sc: true,
        preview_theme_id: true,
        page: true,
      };

      return {
        router: historyRouter({
          // Serialise `{ query, refinementList }` from `routeState` (produced
          // by the singleIndex stateMapping below) into the URL. The
          // canonical query param is `?q=`; refinements use repeated keys
          // (`?collections=a&collections=b`) because `widgets.refinementList`
          // is configured with `operator: 'or'`.
          createURL: function (opts) {
            var url = new URL(window.location.href);
            var routeState = opts.routeState || {};
            var query = routeState.query || '';
            var refinementList = routeState.refinementList || {};

            // `?q=` is owned by the controller (`bindForm` + `normaliseUrl`
            // write it directly via `replaceQueryParam`). The router only
            // overwrites `?q=` when `routeState.query` is set, which never
            // happens today because the query is fed through
            // `widgets.configure({ query })` rather than `searchBox`. Leave
            // whatever's already on the URL alone in the empty-routeState
            // path. Drop legacy `?query=` unconditionally.
            if (query) {
              url.searchParams.set('q', query);
              url.searchParams.delete('query');
            }

            // Wipe any existing facet params (every key NOT in RESERVED) so
            // an unchecked refinement actually disappears from the URL on
            // the next state push.
            var keysToDelete = [];
            url.searchParams.forEach(function (_, key) {
              if (!RESERVED[key]) keysToDelete.push(key);
            });
            keysToDelete.forEach(function (key) {
              url.searchParams.delete(key);
            });

            // Append one entry per selected (facet, value). Repeating the
            // key for multi-value selections matches URLSearchParams' parse
            // contract on read-back.
            Object.keys(refinementList).forEach(function (facet) {
              if (RESERVED[facet]) return;
              var values = refinementList[facet];
              if (!Array.isArray(values)) return;
              values.forEach(function (value) {
                url.searchParams.append(facet, String(value));
              });
            });

            return url.toString();
          },
          // Read URL params back into `{ query, refinementList }`. Every
          // non-reserved key accumulates into the array map; reserved keys
          // pass through (they're handled elsewhere  -  `?tab=` by activateTab,
          // `?q=` by this same function on the next route).
          parseURL: function (opts) {
            var params = new URLSearchParams(opts.location.search);
            var query = params.get('q') || params.get('query') || '';
            var refinementList = {};
            params.forEach(function (value, key) {
              if (RESERVED[key]) return;
              if (!refinementList[key]) refinementList[key] = [];
              refinementList[key].push(value);
            });
            return { query: query, refinementList: refinementList };
          },
        }),
        stateMapping: stateMappings && stateMappings.singleIndex
          ? stateMappings.singleIndex(
              this.algolia.getConfig().productsIndex
            )
          : undefined,
      };
    };

    SearchController.prototype.addProductWidgets = function (cfg) {
      var widgets = this.instantsearch.widgets;
      var self = this;
      var els = this.elements;

      var added = [];

      if (els.stats) {
        added.push(
          widgets.stats({
            container: els.stats,
            templates: {
              text: function (data) {
                // Side effects only: drive the announce live-region, the tab
                // count, the empty-state, and the canonical `.collection-count`
                // element in the actions row (#246 - the count now reuses the
                // PLP `collection-count` component instead of a bespoke string).
                // The "You've viewed X of Y products" load-more line (#214 task
                // 4) is unchanged; this is the PLP-style bar count, not a
                // replacement for it. [data-search-stats] itself stays empty.
                var announceTemplate = data.hasOneResult
                  ? '{count} result for "{query}"'
                  : '{count} results for "{query}"';
                var announced = announceTemplate
                  .replace('{count}', String(data.nbHits))
                  .replace('{query}', data.query || '');
                self.announce(announced);
                self.productCounts.products = data.nbHits;
                self.updateTabCount('products', data.nbHits);
                self.updateResultCount(data.nbHits);
                self.refreshEmptyState();
                return '';
              },
            },
          })
        );
      }

      if (els.productsHits && els.productTemplate) {
        added.push(
          widgets.infiniteHits({
            container: els.productsHits,
            cssClasses: {
              root: 'search-results__hits',
              list: 'product-grid__list',
              item: 'product-grid__item',
            },
            templates: {
              item: function (hit) {
                return self.renderProductHit(hit);
              },
              empty: '',
              showMoreText: '',
            },
            transformItems: function (items, meta) {
              // #341: the index these hits came from -- the products index or
              // the active sort replica. Click events must name the index the
              // search ran on for Algolia to match their `queryID`.
              self.productsResultsIndex =
                (meta && meta.results && meta.results.index) || cfg.productsIndex;
              // #204: mirror the Liquid OOS-hide rule (product-visible.liquid)
              // on the Algolia products tab. A hit is dropped only when the
              // index clearly marks it fully out of stock AND carries no
              // near-term restock signal. When the index does not expose an
              // availability field every hit passes through, so search
              // degrades to its prior behaviour until the index is enriched
              // (see admin_flags - requires `available` / `back_in_stock_date`
              // on the Algolia product records).
              return items.filter(function (hit) {
                return self.hitIsVisible(hit);
              });
            },
          })
        );
      }

      Array.prototype.forEach.call(els.filterGroups, function (group) {
        var facet = group.getAttribute('data-search-filter');
        var body = group.querySelector('[data-search-filter-body]');
        var badge = group.querySelector('[data-search-filter-badge]');
        if (!body || !facet) return;
        // PLP styled option rows (mirrors filter-checkbox.liquid). The widget
        // still owns the click handling (it delegates off the rendered
        // `<label>` + hidden `<input>`); we only swap in PLP class names and a
        // human-readable label + separated count.
        added.push(
          widgets.refinementList({
            container: body,
            attribute: facet,
            operator: 'or',
            limit: facet === 'price_range' ? 20 : 10,
            showMore: facet !== 'price_range',
            showMoreLimit: 30,
            sortBy:
              facet === 'price_range'
                ? ['name:asc']
                : ['isRefined', 'count:desc', 'name:asc'],
            cssClasses: {
              list: 'filter-dropdown__column search-filters__options',
              item: 'search-filters__option',
              label: 'filter-checkbox',
              labelText: 'filter-checkbox__label',
              count: 'filter-checkbox__count',
              selectedItem: 'filter-checkbox--active',
              showMore: 'filter-dropdown__show-more',
              disabledShowMore: 'filter-dropdown__show-more--disabled',
            },
            templates: {
              // Return a plain HTML string for each option row. The widget
              // wraps this in the styled `<label class="filter-checkbox">` and
              // delegates the refine off the contained `<input>` change event,
              // so the hidden native checkbox MUST stay for clicks to toggle
              // the facet. We emit PLP markup around it: a styled box (with the
              // close glyph when active) + label + separated muted count.
              item: function (item) {
                var label = self.facetItemLabel(facet, item.label);
                return (
                  '<span class="filter-checkbox__box" aria-hidden="true">' +
                  (item.isRefined ? self.icons.close : '') +
                  '</span>' +
                  '<input type="checkbox" class="filter-checkbox__native visually-hidden" value="' +
                  self.algolia.escapeHtml(item.value) +
                  '"' +
                  (item.isRefined ? ' checked' : '') +
                  ' />' +
                  '<span class="filter-checkbox__label">' +
                  self.algolia.escapeHtml(label) +
                  '</span>' +
                  '<span class="filter-checkbox__count" aria-hidden="true">(' +
                  String(item.count) +
                  ')</span>'
                );
              },
              showMoreText: function (data) {
                return data.isShowingMore
                  ? self.translations.show_less
                  : self.translations.show_more;
              },
            },
            transformItems: function (items) {
              // Update the PLP-style count badge on the dropdown trigger so a
              // refined facet shows the active count, matching filter-dropdown.
              if (badge) {
                var refinedCount = 0;
                items.forEach(function (it) {
                  if (it.isRefined) refinedCount += 1;
                });
                if (refinedCount > 0) {
                  badge.textContent = String(refinedCount);
                  badge.removeAttribute('hidden');
                  group.classList.add('filter-dropdown--active');
                } else {
                  badge.setAttribute('hidden', '');
                  group.classList.remove('filter-dropdown--active');
                }
              }
              // #244 / QA Slide 4: render the Size facet in garment-size order
              // (XXS→XXL) rather than by count. transformItems has final say on
              // render order, so this overrides the count:desc sortBy above.
              if (facet === 'options.size') {
                return items.slice().sort(function (a, b) {
                  var ra = sizeRank(a.value);
                  var rb = sizeRank(b.value);
                  if (ra !== rb) return ra - rb;
                  return String(a.label).localeCompare(String(b.label));
                });
              }
              return items;
            },
          })
        );
      });

      if (els.currentRefinements) {
        added.push(
          widgets.currentRefinements({
            container: els.currentRefinements,
            cssClasses: {
              list: 'search-current-refinements__list-inner',
              item: 'search-current-refinements__group',
              label: 'visually-hidden',
              category: 'active-chips__chip',
              categoryLabel: 'active-chips__label',
              delete: 'active-chips__close',
            },
            transformItems: function (items) {
              // Re-map raw facet values to human-readable labels so chips read
              // "Maxi Dresses" / "L" / "$100 - $150" rather than handles or
              // bucket strings. The widget groups refinements by attribute;
              // each `refinement.label` is rebuilt per facet.
              items.forEach(function (group) {
                if (!group.refinements) return;
                group.refinements.forEach(function (refinement) {
                  refinement.label = self.facetItemLabel(
                    group.attribute,
                    refinement.label
                  );
                });
              });
              return items;
            },
          })
        );
      }

      if (els.clearRefinementsBtn) {
        // Drive the PLP-styled "Clear all" pill via the connector rather than
        // the stock widget (which would render its own button). We toggle the
        // whole chips container's visibility off the same render signal.
        var connectClearRefinements =
          this.instantsearch.connectors &&
          this.instantsearch.connectors.connectClearRefinements;
        if (connectClearRefinements) {
          var clearRender = connectClearRefinements(function (renderOpts) {
            var refine = renderOpts.refine;
            var canRefine = renderOpts.canRefine;
            if (!els.clearRefinementsBtn.__bound) {
              els.clearRefinementsBtn.__bound = true;
              els.clearRefinementsBtn.addEventListener('click', function () {
                refine();
              });
            }
            if (els.currentRefinementsContainer) {
              if (canRefine) {
                els.currentRefinementsContainer.removeAttribute('hidden');
              } else {
                els.currentRefinementsContainer.setAttribute('hidden', '');
              }
            }
          });
          added.push(clearRender({}));
        }
      }

      if (els.loadMore) {
        added.push(this.createLoadMoreWidget());
      }

      try {
        this.searchInstance.addWidgets(added);
      } catch (err) {
        // Widget add can throw if the dependency missed  -  silently swallow.
      }
    };

    SearchController.prototype.addCollectionWidgets = function (cfg) {
      var widgets = this.instantsearch.widgets;
      var self = this;
      var els = this.elements;
      var added = [];

      if (els.collectionsHits) {
        // List view (#214 task 3): collections render as a flat <ul> of
        // title links matching the headless `SearchResultsView` contract,
        // NOT a card grid. infiniteHits + the collections load-more widget
        // (below) page through all matching collections, lifting the old
        // 12-item cap (task 3 / ambiguity #4).
        added.push(
          widgets.infiniteHits({
            container: els.collectionsHits,
            cssClasses: {
              root: 'search-results__collections-root',
              list: 'search-results__collections',
              item: 'search-results__collection',
            },
            templates: {
              item: function (hit) {
                return self.renderCollectionListItem(hit);
              },
              empty: '',
              showMoreText: '',
            },
            transformItems: function (items) {
              return items;
            },
          })
        );
      }

      // Collections stats: drive the tab count + the "viewed X of Y
      // collections" count line off the real `nbHits` (not the rendered
      // page length, which was the old 12-cap bug).
      if (els.collectionsHits) {
        var connectStats =
          this.instantsearch.connectors &&
          this.instantsearch.connectors.connectStats;
        if (connectStats) {
          var statsRender = connectStats(function (renderOpts) {
            var nb = typeof renderOpts.nbHits === 'number' ? renderOpts.nbHits : 0;
            self.productCounts.collections = nb;
            self.updateTabCount('collections', nb);
            self.refreshEmptyState();
          });
          added.push(statsRender({}));
        }
      }

      if (els.loadMoreCollections) {
        added.push(this.createCollectionsLoadMoreWidget());
      }

      try {
        this.collectionsInstance.addWidgets(added);
      } catch (err) {
        /* swallow */
      }
    };

    SearchController.prototype.createLoadMoreWidget = function () {
      var els = this.elements;
      var self = this;
      var clickBound = false;
      // Custom widget  -  bridges the pre-rendered button to the SAME helper
      // the stock widgets.infiniteHits widget is already driving. We drive
      // pagination off `searchInstance.helper` directly rather than
      // registering a second connectInfiniteHits (which had its own orphaned
      // page state and a stale `showMore` closure  -  see R4 in
      // https://github.com/dotcollectiveanz/runaway-the-label-theme/pull/121).
      return {
        init: function () {
          if (clickBound || !els.loadMore) return;
          clickBound = true;
          els.loadMore.addEventListener('click', function (event) {
            event.preventDefault();
            var instance = self.searchInstance;
            var helper = instance && instance.helper;
            if (!helper) return;
            var last = helper.lastResults;
            var atLast =
              last && typeof last.page === 'number' && typeof last.nbPages === 'number'
                ? last.page >= last.nbPages - 1
                : false;
            if (atLast) return;
            var nextPage = (helper.state && helper.state.page) || 0;
            // Stock widgets.infiniteHits keeps prior pages on screen when
            // setPage advances by one  -  the underlying renderer appends the
            // next batch rather than replacing the grid.
            helper.setPage(nextPage + 1).search();
          });
        },
        render: function (renderOpts) {
          if (!els.loadMore) return;
          var results = renderOpts && renderOpts.results;
          var nbHits = results && typeof results.nbHits === 'number' ? results.nbHits : 0;
          var page = results && typeof results.page === 'number' ? results.page : 0;
          var nbPages = results && typeof results.nbPages === 'number' ? results.nbPages : 0;
          var hitsPerPage =
            results && typeof results.hitsPerPage === 'number'
              ? results.hitsPerPage
              : (results && results.hits ? results.hits.length : 0);
          // Rendered count = hits shown so far across the loaded pages
          // (infiniteHits keeps prior pages on screen).
          var shown = Math.min((page + 1) * hitsPerPage, nbHits);
          if (results && results.hits && (page + 1) >= nbPages) {
            // On the last page the final batch may be partial.
            shown = nbHits;
          }

          // "You've viewed X of Y products" + progress bar (#214 task 4).
          self.renderLoadMoreMeta('products', shown, nbHits);

          var isLastPage = nbPages > 0 ? page >= nbPages - 1 : true;
          if (isLastPage) {
            // No "All results shown" terminal copy any more -- the count line
            // communicates completion. Hide the button; keep the count +
            // progress visible.
            els.loadMore.setAttribute('hidden', '');
            els.loadMore.setAttribute('disabled', 'disabled');
          } else {
            els.loadMore.removeAttribute('hidden');
            els.loadMore.removeAttribute('disabled');
            if (els.loadMoreLabel) {
              els.loadMoreLabel.textContent = self.translations.view_more;
            }
          }
        },
        dispose: function () {},
      };
    };

    /**
     * Collections load-more widget (#214 tasks 3+4). The collections instance
     * uses `infiniteHits` with the products `hitsPerPage` (lifting the old
     * 12-item cap) so all matching collections are reachable via View More.
     * Drives the same count line + progress bar as the products panel,
     * collections-aware.
     */
    SearchController.prototype.createCollectionsLoadMoreWidget = function () {
      var els = this.elements;
      var self = this;
      var clickBound = false;
      return {
        init: function () {
          if (clickBound || !els.loadMoreCollections) return;
          clickBound = true;
          els.loadMoreCollections.addEventListener('click', function (event) {
            event.preventDefault();
            var instance = self.collectionsInstance;
            var helper = instance && instance.helper;
            if (!helper) return;
            var last = helper.lastResults;
            var atLast =
              last && typeof last.page === 'number' && typeof last.nbPages === 'number'
                ? last.page >= last.nbPages - 1
                : false;
            if (atLast) return;
            var nextPage = (helper.state && helper.state.page) || 0;
            helper.setPage(nextPage + 1).search();
          });
        },
        render: function (renderOpts) {
          if (!els.loadMoreCollections) return;
          var results = renderOpts && renderOpts.results;
          var nbHits = results && typeof results.nbHits === 'number' ? results.nbHits : 0;
          var page = results && typeof results.page === 'number' ? results.page : 0;
          var nbPages = results && typeof results.nbPages === 'number' ? results.nbPages : 0;
          var hitsPerPage =
            results && typeof results.hitsPerPage === 'number'
              ? results.hitsPerPage
              : (results && results.hits ? results.hits.length : 0);
          var shown = Math.min((page + 1) * hitsPerPage, nbHits);
          if (results && results.hits && (page + 1) >= nbPages) {
            shown = nbHits;
          }

          self.renderLoadMoreMeta('collections', shown, nbHits);

          var isLastPage = nbPages > 0 ? page >= nbPages - 1 : true;
          if (isLastPage) {
            els.loadMoreCollections.setAttribute('hidden', '');
            els.loadMoreCollections.setAttribute('disabled', 'disabled');
          } else {
            els.loadMoreCollections.removeAttribute('hidden');
            els.loadMoreCollections.removeAttribute('disabled');
            if (els.loadMoreCollectionsLabel) {
              els.loadMoreCollectionsLabel.textContent = self.translations.view_more;
            }
          }
        },
        dispose: function () {},
      };
    };

    /**
     * #204 availability decision for an Algolia product hit. Mirrors
     * snippets/product-visible.liquid: a hit is visible unless it is fully
     * out of stock with no near-term restock. Returns true (keep) whenever
     * the index does not expose an availability flag, so the rule never
     * hides products on an un-enriched index.
     *
     * Recognised availability shapes (first present wins):
     *   hit.available            : boolean  (true = in stock)
     *   hit.inventory_available  : boolean
     *   hit.in_stock             : boolean
     *   hit.inventory_quantity   : number   (>0 = in stock)
     * Restock signal (keeps an OOS hit visible when set to an upcoming date
     * within the next 30 days):
     *   hit.back_in_stock_date   : ISO date / epoch ms / epoch seconds
     */
    SearchController.prototype.hitIsVisible = function (hit) {
      if (!hit) return true;

      var available;
      if (typeof hit.available === 'boolean') {
        available = hit.available;
      } else if (typeof hit.inventory_available === 'boolean') {
        available = hit.inventory_available;
      } else if (typeof hit.in_stock === 'boolean') {
        available = hit.in_stock;
      } else if (typeof hit.inventory_quantity === 'number') {
        available = hit.inventory_quantity > 0;
      } else {
        // No availability field on the index - keep the hit (degrade).
        return true;
      }

      if (available) return true;

      // Fully out of stock: keep only when a near-term restock is signalled.
      var raw = hit.back_in_stock_date;
      if (!raw && raw !== 0) return false;

      var restockMs;
      if (typeof raw === 'number') {
        // Treat 10-digit values as epoch seconds, 13-digit as epoch ms.
        restockMs = raw < 1e12 ? raw * 1000 : raw;
      } else {
        restockMs = Date.parse(raw);
      }
      if (isNaN(restockMs)) return false;

      var now = Date.now();
      var windowMs = 30 * 24 * 60 * 60 * 1000;
      // Upcoming restock that lands inside the look-ahead window.
      return restockMs >= now && restockMs <= now + windowMs;
    };

    SearchController.prototype.renderProductHit = function (hit) {
      var template = this.elements.productTemplate;
      var algolia = this.algolia;
      if (!template) return '';
      var clone = template.content.cloneNode(true);
      var url = algolia.hitProductUrl(hit);
      var title = hit.title || '';
      var price = algolia.formatPrice(hit.price);
      var compareRaw =
        hit.compare_at_price ||
        hit.variants_compare_at_price_min ||
        null;
      var compareNumeric =
        typeof compareRaw === 'number' ? compareRaw : parseFloat(compareRaw);

      var urlSlot = clone.querySelector('[data-slot-url]');
      if (urlSlot) urlSlot.setAttribute('href', url);

      // #341: what `bindInsightsClicks` needs for the Algolia click event.
      // InstantSearch adds `__queryID` (only when the search ran with
      // `clickAnalytics`) and the 1-based absolute `__position` to each hit.
      var card = clone.querySelector('[data-algolia-product-card]');
      if (card && hit.__queryID && hit.objectID) {
        card.setAttribute('data-insights-query-id', hit.__queryID);
        card.setAttribute('data-insights-object-id', hit.objectID);
        card.setAttribute('data-insights-position', hit.__position || '');
        card.setAttribute('data-insights-index', this.productsResultsIndex || '');
        if (hit.id) card.setAttribute('data-insights-product-id', hit.id);
      }

      var titleSlot = clone.querySelector('[data-slot-title]');
      if (titleSlot) titleSlot.textContent = title;

      // QA round 1 items 1o / M1f: NOW price red when on sale.
      var slotOnSale =
        !isNaN(compareNumeric) &&
        compareNumeric > parseFloat(hit.price || 0);

      var priceSlot = clone.querySelector('[data-slot-price]');
      if (priceSlot) {
        priceSlot.textContent = price;
        if (slotOnSale) priceSlot.classList.add('product-card__price--on-sale');
      }

      var compareSlot = clone.querySelector('[data-slot-compare]');
      if (compareSlot && slotOnSale) {
        compareSlot.textContent = algolia.formatPrice(compareNumeric);
        compareSlot.removeAttribute('hidden');
      }

      var imageSlot = clone.querySelector('[data-slot-image]');
      if (imageSlot) {
        var src =
          (hit.image && hit.image.src) ||
          hit.image ||
          hit.product_image ||
          '';
        if (src) {
          var img = document.createElement('img');
          img.setAttribute('src', src);
          img.setAttribute('alt', title);
          img.setAttribute('loading', 'lazy');
          imageSlot.appendChild(img);
        }
      }

      // #327: badges resolve through the shared `RTLAlgolia.resolveBadges`
      // port of `snippets/product-badge.liquid`, so a hit shows exactly the
      // badge the PLP card shows -- promo `badge:<text>` (which the previous
      // `hit.tags` lookup could never see, because Algolia moves `key:value`
      // tags into `named_tags`), `badge:none` suppression, and the
      // RESTOCKING > BACK IN STOCK > NEW > SALE ladder.
      var badges = algolia.resolveBadges(hit);
      var promoSlot = clone.querySelector('[data-slot-badge-promo]');
      if (promoSlot && badges.promo) {
        promoSlot.textContent = badges.promo;
        promoSlot.removeAttribute('hidden');
      }
      var statusSlot = clone.querySelector('[data-slot-badge-status]');
      if (statusSlot && badges.status) {
        statusSlot.textContent = badges.status;
        if (badges.statusModifier) {
          statusSlot.classList.add(badges.statusModifier);
        }
        statusSlot.removeAttribute('hidden');
      }

      var wrapper = document.createElement('div');
      wrapper.appendChild(clone);
      return wrapper.innerHTML;
    };

    /**
     * Collections list-view item (#214 task 3). Renders a flat list row -- a
     * single title link -- matching the headless `SearchResultsView`
     * `<li><Link><Text text={result.title}/></li>` contract. No card / image /
     * count. The wrapping <li> is supplied by the infiniteHits widget.
     */
    SearchController.prototype.renderCollectionListItem = function (hit) {
      var algolia = this.algolia;
      var url = algolia.hitCollectionUrl(hit);
      var title = hit && hit.title ? hit.title : '';
      var a = document.createElement('a');
      a.className = 'search-results__collection-link';
      a.setAttribute('href', url);
      a.textContent = title;
      var wrapper = document.createElement('div');
      wrapper.appendChild(a);
      return wrapper.innerHTML;
    };

    SearchController.prototype.renderCollectionHit = function (hit) {
      var template = this.elements.collectionTemplate;
      var algolia = this.algolia;
      if (!template) return '';
      var clone = template.content.cloneNode(true);

      var urlSlot = clone.querySelector('[data-slot-url]');
      if (urlSlot) urlSlot.setAttribute('href', algolia.hitCollectionUrl(hit));

      var titleSlot = clone.querySelector('[data-slot-title]');
      if (titleSlot) titleSlot.textContent = hit.title || '';

      var countSlot = clone.querySelector('[data-slot-count]');
      if (countSlot) {
        countSlot.textContent =
          hit.products_count !== undefined ? hit.products_count : 0;
      }

      var imageSlot = clone.querySelector('[data-slot-image]');
      if (imageSlot) {
        var src = (hit.image && (hit.image.src || hit.image)) || '';
        if (src) {
          var img = document.createElement('img');
          img.setAttribute('src', src);
          img.setAttribute('alt', hit.title || '');
          img.setAttribute('loading', 'lazy');
          imageSlot.appendChild(img);
        }
      }

      var wrapper = document.createElement('div');
      wrapper.appendChild(clone);
      return wrapper.innerHTML;
    };

    SearchController.prototype.updateTabCount = function (name, count) {
      var node = this.elements.tabCounts[name];
      if (!node) return;
      var value = count || 0;
      // Live AU hides the count when there are zero hits; show '(N)' otherwise.
      if (value > 0) {
        node.textContent = '(' + String(count || 0) + ')';
        node.hidden = false;
      } else {
        node.textContent = '';
        node.hidden = true;
      }
      this.productCounts[name] = count || 0;
    };

    SearchController.prototype.updateResultCount = function (count) {
      // Write the live Algolia result count into the canonical
      // `.collection-count` element (#246). The element + its class are
      // server-rendered so the count inherits the PLP style
      // (14px/500/uppercase/0.7px); the JS only writes the formatted string.
      var node = this.elements.count;
      if (!node) return;
      var n = count || 0;
      var formatted = n.toLocaleString();
      var template =
        n === 1
          ? this.translations.result_count_one
          : this.translations.result_count_other;
      node.textContent = template.replace('__COUNT__', formatted);
    };

    SearchController.prototype.announce = function (message) {
      if (!this.elements.liveRegion) return;
      this.elements.liveRegion.textContent = message;
    };

    SearchController.prototype.refreshEmptyState = function () {
      if (!this.elements.emptyState) return;
      var counts = this.productCounts;
      var active = this.activeTab;
      var nbHits = counts[active] || 0;
      var query = this.elements.input ? this.elements.input.value : '';

      if (nbHits === 0 && query) {
        // The empty-state tagline is a static, query-independent message
        // rendered server-side; do not overwrite it with the live query.
        this.elements.emptyState.removeAttribute('hidden');
        if (active === 'products' && this.elements.panels.products) {
          this.elements.panels.products.classList.add(
            'search-results__panel--empty'
          );
        }
      } else {
        this.elements.emptyState.setAttribute('hidden', '');
      }
    };

    SearchController.prototype.dispose = function () {
      try {
        if (this.searchInstance && this.searchInstance.dispose) {
          this.searchInstance.dispose();
        }
        if (this.collectionsInstance && this.collectionsInstance.dispose) {
          this.collectionsInstance.dispose();
        }
      } catch (err) {
        /* swallow */
      }
      this.searchInstance = null;
      this.collectionsInstance = null;
    };

    /**
     * The section JS, the Algolia/InstantSearch UMD bundles, and
     * `algolia-client.js` are all loaded via `<script defer>` from
     * `theme.liquid`. Defer scripts run in document order before
     * `DOMContentLoaded`, but Shopify bundles section javascript blocks
     * into `section.search.js` which sits lower in the document and
     * frequently races the head-defer queue's third entry. The previous
     * constructor null-guard on `window.RTLAlgolia` / `window.instantsearch`
     * silently swallowed the early-arrival case and left the page in the
     * no-JS fallback state forever (R1/R2/R3 from PR #121 review).
     *
     * Wait for the helper bridge (`window.RTLAlgolia`) to exist, then await
     * its `ready()` which polls until both UMD globals are present. Only
     * then mount the controller  -  by which point reading `window.RTLAlgolia`
     * and `window.instantsearch` from the constructor is guaranteed to
     * succeed.
     */
    function mountAllSections() {
      var roots = document.querySelectorAll('[data-search-section]');
      Array.prototype.forEach.call(roots, function (root) {
        if (!root.__rtlSearchController) {
          root.__rtlSearchController = new SearchController(root);
        }
      });
    }

    function waitForBridge(callback) {
      if (window.RTLAlgolia && typeof window.RTLAlgolia.ready === 'function') {
        callback();
        return;
      }
      var started = Date.now();
      var TIMEOUT_MS = 10000;
      (function tick() {
        if (
          window.RTLAlgolia &&
          typeof window.RTLAlgolia.ready === 'function'
        ) {
          callback();
          return;
        }
        if (Date.now() - started > TIMEOUT_MS) {
          // Give up and let the no-JS shell stand.
          return;
        }
        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(tick);
        } else {
          setTimeout(tick, 16);
        }
      })();
    }

    // #341: hold the first search until Shopify's consent API has loaded (at
    // most ~1s, usually no wait), so it carries `clickAnalytics` when the
    // shopper allows analytics -- otherwise clicks on the first page of
    // results could never be attributed. `whenReady()` never rejects.
    function insightsReady() {
      var insights = window.RTLAlgoliaInsights;
      return insights && typeof insights.whenReady === 'function'
        ? insights.whenReady()
        : null;
    }

    function init() {
      waitForBridge(function () {
        window.RTLAlgolia.ready()
          .then(insightsReady)
          .then(mountAllSections, function () {
            /* Timed out waiting for UMD globals  -  fall back to no-JS shell. */
          });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Theme editor remount  -  same wait-for-bridge gate keeps idempotency.
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[data-search-section]');
      if (section && !section.__rtlSearchController) {
        waitForBridge(function () {
          window.RTLAlgolia.ready().then(function () {
            if (!section.__rtlSearchController) {
              section.__rtlSearchController = new SearchController(section);
            }
          });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero"] && !Shopify.designMode) return;
  try {
    
  // Swap section-hero <img> between desktop / mobile sources at the
  // 1025px breakpoint (matches headless `large-tablet` and the
  // HeroMedia.tsx MOBILE_BREAKPOINT). Runs on load + on resize. Each
  // image element decides its own state via data-* attributes so the
  // script is harmless on pages without a hero.
  (function () {
    var MQ = window.matchMedia('(max-width: 1024px)');
    var imgs = document.querySelectorAll('img.section-hero__image[data-mobile-src]');
    if (!imgs.length) return;

    function apply(img) {
      var useMobile = MQ.matches;
      var src = useMobile ? img.getAttribute('data-mobile-src') : img.getAttribute('data-desktop-src');
      var srcset = useMobile ? img.getAttribute('data-mobile-srcset') : img.getAttribute('data-desktop-srcset');
      if (src && img.src !== src) img.src = src;
      if (srcset && img.srcset !== srcset) img.srcset = srcset;
    }

    imgs.forEach(apply);

    var onChange = function () { imgs.forEach(apply); };
    if (MQ.addEventListener) {
      MQ.addEventListener('change', onChange);
    } else if (MQ.addListener) {
      MQ.addListener(onChange);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  // Size-guide unit toggle. Each chart block carries its own toggle
  // and table pair. Click flips the active button and swaps which
  // [data-unit] table is visible. Scope is per chart block, so two
  // charts on the page do not interfere with each other.
  (function () {
    var blocks = document.querySelectorAll('.size-guide-content__chart-block');
    if (!blocks || !blocks.length) return;

    blocks.forEach(function (block) {
      var buttons = block.querySelectorAll('.size-guide-content__chart-toggle-btn');
      var tables = block.querySelectorAll('[data-unit]');
      if (!buttons.length || tables.length < 2) return;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-unit-target');
          if (!target) return;

          buttons.forEach(function (b) {
            var isActive = b === btn;
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          tables.forEach(function (t) {
            var match = t.getAttribute('data-unit') === target;
            if (match) {
              t.removeAttribute('hidden');
            } else {
              t.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wysiwyg-with-toc"] && !Shopify.designMode) return;
  try {
    
  // Scroll-spy + click-active for the wysiwyg-with-toc section. Matches the
  // headless IntersectionObserver pattern: anchor div crossing the top 5% of
  // the viewport promotes the matching TOC link to .is-active. Click handler
  // promotes the clicked link immediately so the UI feels snappy.

  (function () {
    function init(root) {
      if (!root || root.__wwtBound) return;
      root.__wwtBound = true;

      var links = root.querySelectorAll('[data-toc-link]');
      if (!links.length) return;

      var anchors = root.querySelectorAll('.wysiwyg-with-toc__anchor');
      if (!anchors.length) return;

      function setActive(slug) {
        for (var i = 0; i < links.length; i++) {
          if (links[i].getAttribute('data-toc-link') === slug) {
            links[i].classList.add('is-active');
          } else {
            links[i].classList.remove('is-active');
          }
        }
      }

      // Click handler -- promote the clicked link instantly. The native
      // anchor jump runs alongside; the observer catches up after scroll.
      for (var j = 0; j < links.length; j++) {
        (function (link) {
          link.addEventListener('click', function () {
            setActive(link.getAttribute('data-toc-link'));
          });
        })(links[j]);
      }

      // IntersectionObserver -- rootMargin top 5% means an anchor must reach
      // the top 5% of the viewport before it counts as the active section.
      if (typeof IntersectionObserver === 'undefined') return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.target.id) {
            setActive(entry.target.id);
          }
        });
      }, {
        root: null,
        rootMargin: '0px 0px -95% 0px',
        threshold: 1.0,
      });

      for (var k = 0; k < anchors.length; k++) {
        observer.observe(anchors[k]);
      }
    }

    function boot() {
      var roots = document.querySelectorAll('[data-section-type="wysiwyg-with-toc"]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-section-type="wysiwyg-with-toc"]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
